/**
 * Name: @redventures/beam
 * Version: 1.4.0
 * Generated: 2020-01-24
 */

(function () {
  "use strict";
  var commonjsGlobal = typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
  function unwrapExports(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x.default : x;
  }
  function createCommonjsModule(fn, module) {
    return module = {
      exports: {}
    }, fn(module, module.exports), module.exports;
  }
  var _global = createCommonjsModule(function (module) {
    var global = module.exports = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
    if (typeof __g == "number") __g = global;
  });
  var _core = createCommonjsModule(function (module) {
    var core = module.exports = {
      version: "2.5.7"
    };
    if (typeof __e == "number") __e = core;
  });
  var _core_1 = _core.version;
  var _isObject = function (it) {
    return typeof it === "object" ? it !== null : typeof it === "function";
  };
  var _anObject = function (it) {
    if (!_isObject(it)) throw TypeError(it + " is not an object!");
    return it;
  };
  var _fails = function (exec) {
    try {
      return !!exec();
    } catch (e) {
      return true;
    }
  };
  var _descriptors = !_fails(function () {
    return Object.defineProperty({}, "a", {
      get: function () {
        return 7;
      }
    }).a != 7;
  });
  var document$1 = _global.document;
  var is = _isObject(document$1) && _isObject(document$1.createElement);
  var _domCreate = function (it) {
    return is ? document$1.createElement(it) : {};
  };
  var _ie8DomDefine = !_descriptors && !_fails(function () {
    return Object.defineProperty(_domCreate("div"), "a", {
      get: function () {
        return 7;
      }
    }).a != 7;
  });
  var _toPrimitive = function (it, S) {
    if (!_isObject(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == "function" && !_isObject(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == "function" && !_isObject(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == "function" && !_isObject(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
  };
  var dP = Object.defineProperty;
  var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    _anObject(O);
    P = _toPrimitive(P, true);
    _anObject(Attributes);
    if (_ie8DomDefine) try {
      return dP(O, P, Attributes);
    } catch (e) { }
    if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported!");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
  };
  var _objectDp = {
    f: f
  };
  var _propertyDesc = function (bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };
  var _hide = _descriptors ? function (object, key, value) {
    return _objectDp.f(object, key, _propertyDesc(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };
  var hasOwnProperty = {}.hasOwnProperty;
  var _has = function (it, key) {
    return hasOwnProperty.call(it, key);
  };
  var id = 0;
  var px = Math.random();
  var _uid = function (key) {
    return "Symbol(".concat(key === undefined ? "" : key, ")_", (++id + px).toString(36));
  };
  var _redefine = createCommonjsModule(function (module) {
    var SRC = _uid("src");
    var TO_STRING = "toString";
    var $toString = Function[TO_STRING];
    var TPL = ("" + $toString).split(TO_STRING);
    _core.inspectSource = function (it) {
      return $toString.call(it);
    };
    (module.exports = function (O, key, val, safe) {
      var isFunction = typeof val == "function";
      if (isFunction) _has(val, "name") || _hide(val, "name", key);
      if (O[key] === val) return;
      if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? "" + O[key] : TPL.join(String(key)));
      if (O === _global) {
        O[key] = val;
      } else if (!safe) {
        delete O[key];
        _hide(O, key, val);
      } else if (O[key]) {
        O[key] = val;
      } else {
        _hide(O, key, val);
      }
    })(Function.prototype, TO_STRING, function toString() {
      return typeof this == "function" && this[SRC] || $toString.call(this);
    });
  });
  var _aFunction = function (it) {
    if (typeof it != "function") throw TypeError(it + " is not a function!");
    return it;
  };
  var _ctx = function (fn, that, length) {
    _aFunction(fn);
    if (that === undefined) return fn;
    switch (length) {
      case 1:
        return function (a) {
          return fn.call(that, a);
        };

      case 2:
        return function (a, b) {
          return fn.call(that, a, b);
        };

      case 3:
        return function (a, b, c) {
          return fn.call(that, a, b, c);
        };
    }
    return function () {
      return fn.apply(that, arguments);
    };
  };
  var PROTOTYPE = "prototype";
  var $export = function (type, name, source) {
    var IS_FORCED = type & $export.F;
    var IS_GLOBAL = type & $export.G;
    var IS_STATIC = type & $export.S;
    var IS_PROTO = type & $export.P;
    var IS_BIND = type & $export.B;
    var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
    var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
    var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
    var key, own, out, exp;
    if (IS_GLOBAL) source = name;
    for (key in source) {
      own = !IS_FORCED && target && target[key] !== undefined;
      out = (own ? target : source)[key];
      exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == "function" ? _ctx(Function.call, out) : out;
      if (target) _redefine(target, key, out, type & $export.U);
      if (exports[key] != out) _hide(exports, key, exp);
      if (IS_PROTO && expProto[key] != out) expProto[key] = out;
    }
  };
  _global.core = _core;
  $export.F = 1;
  $export.G = 2;
  $export.S = 4;
  $export.P = 8;
  $export.B = 16;
  $export.W = 32;
  $export.U = 64;
  $export.R = 128;
  var _export = $export;
  var _defined = function (it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
  };
  var _toObject = function (it) {
    return Object(_defined(it));
  };
  var ceil = Math.ceil;
  var floor = Math.floor;
  var _toInteger = function (it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
  };
  var max = Math.max;
  var min = Math.min;
  var _toAbsoluteIndex = function (index, length) {
    index = _toInteger(index);
    return index < 0 ? max(index + length, 0) : min(index, length);
  };
  var min$1 = Math.min;
  var _toLength = function (it) {
    return it > 0 ? min$1(_toInteger(it), 9007199254740991) : 0;
  };
  var _arrayCopyWithin = [].copyWithin || function copyWithin(target, start) {
    var O = _toObject(this);
    var len = _toLength(O.length);
    var to = _toAbsoluteIndex(target, len);
    var from = _toAbsoluteIndex(start, len);
    var end = arguments.length > 2 ? arguments[2] : undefined;
    var count = Math.min((end === undefined ? len : _toAbsoluteIndex(end, len)) - from, len - to);
    var inc = 1;
    if (from < to && to < from + count) {
      inc = -1;
      from += count - 1;
      to += count - 1;
    }
    while (count-- > 0) {
      if (from in O) O[to] = O[from]; else delete O[to];
      to += inc;
      from += inc;
    }
    return O;
  };
  var _library = false;
  var _shared = createCommonjsModule(function (module) {
    var SHARED = "__core-js_shared__";
    var store = _global[SHARED] || (_global[SHARED] = {});
    (module.exports = function (key, value) {
      return store[key] || (store[key] = value !== undefined ? value : {});
    })("versions", []).push({
      version: _core.version,
      mode: "global",
      copyright: "© 2018 Denis Pushkarev (zloirock.ru)"
    });
  });
  var _wks = createCommonjsModule(function (module) {
    var store = _shared("wks");
    var Symbol = _global.Symbol;
    var USE_SYMBOL = typeof Symbol == "function";
    var $exports = module.exports = function (name) {
      return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)("Symbol." + name));
    };
    $exports.store = store;
  });
  var UNSCOPABLES = _wks("unscopables");
  var ArrayProto = Array.prototype;
  if (ArrayProto[UNSCOPABLES] == undefined) _hide(ArrayProto, UNSCOPABLES, {});
  var _addToUnscopables = function (key) {
    ArrayProto[UNSCOPABLES][key] = true;
  };
  _export(_export.P, "Array", {
    copyWithin: _arrayCopyWithin
  });
  _addToUnscopables("copyWithin");
  var _arrayFill = function fill(value) {
    var O = _toObject(this);
    var length = _toLength(O.length);
    var aLen = arguments.length;
    var index = _toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
    var end = aLen > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : _toAbsoluteIndex(end, length);
    while (endPos > index) O[index++] = value;
    return O;
  };
  _export(_export.P, "Array", {
    fill: _arrayFill
  });
  _addToUnscopables("fill");
  var toString = {}.toString;
  var _cof = function (it) {
    return toString.call(it).slice(8, -1);
  };
  var _iobject = Object("z").propertyIsEnumerable(0) ? Object : function (it) {
    return _cof(it) == "String" ? it.split("") : Object(it);
  };
  var _isArray = Array.isArray || function isArray(arg) {
    return _cof(arg) == "Array";
  };
  var SPECIES = _wks("species");
  var _arraySpeciesConstructor = function (original) {
    var C;
    if (_isArray(original)) {
      C = original.constructor;
      if (typeof C == "function" && (C === Array || _isArray(C.prototype))) C = undefined;
      if (_isObject(C)) {
        C = C[SPECIES];
        if (C === null) C = undefined;
      }
    }
    return C === undefined ? Array : C;
  };
  var _arraySpeciesCreate = function (original, length) {
    return new (_arraySpeciesConstructor(original))(length);
  };
  var _arrayMethods = function (TYPE, $create) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    var create = $create || _arraySpeciesCreate;
    return function ($this, callbackfn, that) {
      var O = _toObject($this);
      var self = _iobject(O);
      var f = _ctx(callbackfn, that, 3);
      var length = _toLength(self.length);
      var index = 0;
      var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
      var val, res;
      for (; length > index; index++) if (NO_HOLES || index in self) {
        val = self[index];
        res = f(val, index, O);
        if (TYPE) {
          if (IS_MAP) result[index] = res; else if (res) switch (TYPE) {
            case 3:
              return true;

            case 5:
              return val;

            case 6:
              return index;

            case 2:
              result.push(val);
          } else if (IS_EVERY) return false;
        }
      }
      return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
    };
  };
  var $find = _arrayMethods(5);
  var KEY = "find";
  var forced = true;
  if (KEY in []) Array(1)[KEY](function () {
    forced = false;
  });
  _export(_export.P + _export.F * forced, "Array", {
    find: function find(callbackfn) {
      return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  _addToUnscopables(KEY);
  var $find$1 = _arrayMethods(6);
  var KEY$1 = "findIndex";
  var forced$1 = true;
  if (KEY$1 in []) Array(1)[KEY$1](function () {
    forced$1 = false;
  });
  _export(_export.P + _export.F * forced$1, "Array", {
    findIndex: function findIndex(callbackfn) {
      return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  _addToUnscopables(KEY$1);
  var _iterCall = function (iterator, fn, value, entries) {
    try {
      return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
    } catch (e) {
      var ret = iterator["return"];
      if (ret !== undefined) _anObject(ret.call(iterator));
      throw e;
    }
  };
  var _iterators = {};
  var ITERATOR = _wks("iterator");
  var ArrayProto$1 = Array.prototype;
  var _isArrayIter = function (it) {
    return it !== undefined && (_iterators.Array === it || ArrayProto$1[ITERATOR] === it);
  };
  var _createProperty = function (object, index, value) {
    if (index in object) _objectDp.f(object, index, _propertyDesc(0, value)); else object[index] = value;
  };
  var TAG = _wks("toStringTag");
  var ARG = _cof(function () {
    return arguments;
  }()) == "Arguments";
  var tryGet = function (it, key) {
    try {
      return it[key];
    } catch (e) { }
  };
  var _classof = function (it) {
    var O, T, B;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (T = tryGet(O = Object(it), TAG)) == "string" ? T : ARG ? _cof(O) : (B = _cof(O)) == "Object" && typeof O.callee == "function" ? "Arguments" : B;
  };
  var ITERATOR$1 = _wks("iterator");
  var core_getIteratorMethod = _core.getIteratorMethod = function (it) {
    if (it != undefined) return it[ITERATOR$1] || it["@@iterator"] || _iterators[_classof(it)];
  };
  var ITERATOR$2 = _wks("iterator");
  var SAFE_CLOSING = false;
  try {
    var riter = [7][ITERATOR$2]();
    riter["return"] = function () {
      SAFE_CLOSING = true;
    };
  } catch (e) { }
  var _iterDetect = function (exec, skipClosing) {
    if (!skipClosing && !SAFE_CLOSING) return false;
    var safe = false;
    try {
      var arr = [7];
      var iter = arr[ITERATOR$2]();
      iter.next = function () {
        return {
          done: safe = true
        };
      };
      arr[ITERATOR$2] = function () {
        return iter;
      };
      exec(arr);
    } catch (e) { }
    return safe;
  };
  _export(_export.S + _export.F * !_iterDetect(function (iter) { }), "Array", {
    from: function from(arrayLike) {
      var O = _toObject(arrayLike);
      var C = typeof this == "function" ? this : Array;
      var aLen = arguments.length;
      var mapfn = aLen > 1 ? arguments[1] : undefined;
      var mapping = mapfn !== undefined;
      var index = 0;
      var iterFn = core_getIteratorMethod(O);
      var length, result, step, iterator;
      if (mapping) mapfn = _ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
      if (iterFn != undefined && !(C == Array && _isArrayIter(iterFn))) {
        for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
          _createProperty(result, index, mapping ? _iterCall(iterator, mapfn, [step.value, index], true) : step.value);
        }
      } else {
        length = _toLength(O.length);
        for (result = new C(length); length > index; index++) {
          _createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
        }
      }
      result.length = index;
      return result;
    }
  });
  var _toIobject = function (it) {
    return _iobject(_defined(it));
  };
  var _arrayIncludes = function (IS_INCLUDES) {
    return function ($this, el, fromIndex) {
      var O = _toIobject($this);
      var length = _toLength(O.length);
      var index = _toAbsoluteIndex(fromIndex, length);
      var value;
      if (IS_INCLUDES && el != el) while (length > index) {
        value = O[index++];
        if (value != value) return true;
      } else for (; length > index; index++) if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
      return !IS_INCLUDES && -1;
    };
  };
  var $includes = _arrayIncludes(true);
  _export(_export.P, "Array", {
    includes: function includes(el) {
      return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  _addToUnscopables("includes");
  var _iterStep = function (done, value) {
    return {
      value: value,
      done: !!done
    };
  };
  var shared = _shared("keys");
  var _sharedKey = function (key) {
    return shared[key] || (shared[key] = _uid(key));
  };
  var arrayIndexOf = _arrayIncludes(false);
  var IE_PROTO = _sharedKey("IE_PROTO");
  var _objectKeysInternal = function (object, names) {
    var O = _toIobject(object);
    var i = 0;
    var result = [];
    var key;
    for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
    while (names.length > i) if (_has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
    return result;
  };
  var _enumBugKeys = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  var _objectKeys = Object.keys || function keys(O) {
    return _objectKeysInternal(O, _enumBugKeys);
  };
  var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
    _anObject(O);
    var keys = _objectKeys(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
    return O;
  };
  var document$2 = _global.document;
  var _html = document$2 && document$2.documentElement;
  var IE_PROTO$1 = _sharedKey("IE_PROTO");
  var Empty = function () { };
  var PROTOTYPE$1 = "prototype";
  var createDict = function () {
    var iframe = _domCreate("iframe");
    var i = _enumBugKeys.length;
    var lt = "<";
    var gt = ">";
    var iframeDocument;
    iframe.style.display = "none";
    _html.appendChild(iframe);
    iframe.src = "javascript:";
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + "script" + gt + "document.F=Object" + lt + "/script" + gt);
    iframeDocument.close();
    createDict = iframeDocument.F;
    while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
    return createDict();
  };
  var _objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
      Empty[PROTOTYPE$1] = _anObject(O);
      result = new Empty();
      Empty[PROTOTYPE$1] = null;
      result[IE_PROTO$1] = O;
    } else result = createDict();
    return Properties === undefined ? result : _objectDps(result, Properties);
  };
  var def = _objectDp.f;
  var TAG$1 = _wks("toStringTag");
  var _setToStringTag = function (it, tag, stat) {
    if (it && !_has(it = stat ? it : it.prototype, TAG$1)) def(it, TAG$1, {
      configurable: true,
      value: tag
    });
  };
  var IteratorPrototype = {};
  _hide(IteratorPrototype, _wks("iterator"), function () {
    return this;
  });
  var _iterCreate = function (Constructor, NAME, next) {
    Constructor.prototype = _objectCreate(IteratorPrototype, {
      next: _propertyDesc(1, next)
    });
    _setToStringTag(Constructor, NAME + " Iterator");
  };
  var IE_PROTO$2 = _sharedKey("IE_PROTO");
  var ObjectProto = Object.prototype;
  var _objectGpo = Object.getPrototypeOf || function (O) {
    O = _toObject(O);
    if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
    if (typeof O.constructor == "function" && O instanceof O.constructor) {
      return O.constructor.prototype;
    }
    return O instanceof Object ? ObjectProto : null;
  };
  var ITERATOR$3 = _wks("iterator");
  var BUGGY = !([].keys && "next" in [].keys());
  var FF_ITERATOR = "@@iterator";
  var KEYS = "keys";
  var VALUES = "values";
  var returnThis = function () {
    return this;
  };
  var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    _iterCreate(Constructor, NAME, next);
    var getMethod = function (kind) {
      if (!BUGGY && kind in proto) return proto[kind];
      switch (kind) {
        case KEYS:
          return function keys() {
            return new Constructor(this, kind);
          };

        case VALUES:
          return function values() {
            return new Constructor(this, kind);
          };
      }
      return function entries() {
        return new Constructor(this, kind);
      };
    };
    var TAG = NAME + " Iterator";
    var DEF_VALUES = DEFAULT == VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[ITERATOR$3] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod("entries") : undefined;
    var $anyNative = NAME == "Array" ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    if ($anyNative) {
      IteratorPrototype = _objectGpo($anyNative.call(new Base()));
      if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
        _setToStringTag(IteratorPrototype, TAG, true);
        if (!_library && typeof IteratorPrototype[ITERATOR$3] != "function") _hide(IteratorPrototype, ITERATOR$3, returnThis);
      }
    }
    if (DEF_VALUES && $native && $native.name !== VALUES) {
      VALUES_BUG = true;
      $default = function values() {
        return $native.call(this);
      };
    }
    if ((!_library || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR$3])) {
      _hide(proto, ITERATOR$3, $default);
    }
    _iterators[NAME] = $default;
    _iterators[TAG] = returnThis;
    if (DEFAULT) {
      methods = {
        values: DEF_VALUES ? $default : getMethod(VALUES),
        keys: IS_SET ? $default : getMethod(KEYS),
        entries: $entries
      };
      if (FORCED) for (key in methods) {
        if (!(key in proto)) _redefine(proto, key, methods[key]);
      } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
  };
  var es6_array_iterator = _iterDefine(Array, "Array", function (iterated, kind) {
    this._t = _toIobject(iterated);
    this._i = 0;
    this._k = kind;
  }, function () {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
      this._t = undefined;
      return _iterStep(1);
    }
    if (kind == "keys") return _iterStep(0, index);
    if (kind == "values") return _iterStep(0, O[index]);
    return _iterStep(0, [index, O[index]]);
  }, "values");
  _iterators.Arguments = _iterators.Array;
  _addToUnscopables("keys");
  _addToUnscopables("values");
  _addToUnscopables("entries");
  _export(_export.S + _export.F * _fails(function () {
    function F() { }
    return !(Array.of.call(F) instanceof F);
  }), "Array", {
    of: function of() {
      var index = 0;
      var aLen = arguments.length;
      var result = new (typeof this == "function" ? this : Array)(aLen);
      while (aLen > index) _createProperty(result, index, arguments[index++]);
      result.length = aLen;
      return result;
    }
  });
  var _strictMethod = function (method, arg) {
    return !!method && _fails(function () {
      arg ? method.call(null, function () { }, 1) : method.call(null);
    });
  };
  var $sort = [].sort;
  var test = [1, 2, 3];
  _export(_export.P + _export.F * (_fails(function () {
    test.sort(undefined);
  }) || !_fails(function () {
    test.sort(null);
  }) || !_strictMethod($sort)), "Array", {
    sort: function sort(comparefn) {
      return comparefn === undefined ? $sort.call(_toObject(this)) : $sort.call(_toObject(this), _aFunction(comparefn));
    }
  });
  var SPECIES$1 = _wks("species");
  var _setSpecies = function (KEY) {
    var C = _global[KEY];
    if (_descriptors && C && !C[SPECIES$1]) _objectDp.f(C, SPECIES$1, {
      configurable: true,
      get: function () {
        return this;
      }
    });
  };
  _setSpecies("Array");
  var NUMBER = "number";
  var _dateToPrimitive = function (hint) {
    if (hint !== "string" && hint !== NUMBER && hint !== "default") throw TypeError("Incorrect hint");
    return _toPrimitive(_anObject(this), hint != NUMBER);
  };
  var TO_PRIMITIVE = _wks("toPrimitive");
  var proto = Date.prototype;
  if (!(TO_PRIMITIVE in proto)) _hide(proto, TO_PRIMITIVE, _dateToPrimitive);
  var HAS_INSTANCE = _wks("hasInstance");
  var FunctionProto = Function.prototype;
  if (!(HAS_INSTANCE in FunctionProto)) _objectDp.f(FunctionProto, HAS_INSTANCE, {
    value: function (O) {
      if (typeof this != "function" || !_isObject(O)) return false;
      if (!_isObject(this.prototype)) return O instanceof this;
      while (O = _objectGpo(O)) if (this.prototype === O) return true;
      return false;
    }
  });
  var dP$1 = _objectDp.f;
  var FProto = Function.prototype;
  var nameRE = /^\s*function ([^ (]*)/;
  var NAME = "name";
  NAME in FProto || _descriptors && dP$1(FProto, NAME, {
    configurable: true,
    get: function () {
      try {
        return ("" + this).match(nameRE)[1];
      } catch (e) {
        return "";
      }
    }
  });
  var _redefineAll = function (target, src, safe) {
    for (var key in src) _redefine(target, key, src[key], safe);
    return target;
  };
  var _anInstance = function (it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
      throw TypeError(name + ": incorrect invocation!");
    }
    return it;
  };
  var _forOf = createCommonjsModule(function (module) {
    var BREAK = {};
    var RETURN = {};
    var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
      var iterFn = ITERATOR ? function () {
        return iterable;
      } : core_getIteratorMethod(iterable);
      var f = _ctx(fn, that, entries ? 2 : 1);
      var index = 0;
      var length, step, iterator, result;
      if (typeof iterFn != "function") throw TypeError(iterable + " is not iterable!");
      if (_isArrayIter(iterFn)) for (length = _toLength(iterable.length); length > index; index++) {
        result = entries ? f(_anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === BREAK || result === RETURN) return result;
      } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
        result = _iterCall(iterator, f, step.value, entries);
        if (result === BREAK || result === RETURN) return result;
      }
    };
    exports.BREAK = BREAK;
    exports.RETURN = RETURN;
  });
  var _meta = createCommonjsModule(function (module) {
    var META = _uid("meta");
    var setDesc = _objectDp.f;
    var id = 0;
    var isExtensible = Object.isExtensible || function () {
      return true;
    };
    var FREEZE = !_fails(function () {
      return isExtensible(Object.preventExtensions({}));
    });
    var setMeta = function (it) {
      setDesc(it, META, {
        value: {
          i: "O" + ++id,
          w: {}
        }
      });
    };
    var fastKey = function (it, create) {
      if (!_isObject(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
      if (!_has(it, META)) {
        if (!isExtensible(it)) return "F";
        if (!create) return "E";
        setMeta(it);
      }
      return it[META].i;
    };
    var getWeak = function (it, create) {
      if (!_has(it, META)) {
        if (!isExtensible(it)) return true;
        if (!create) return false;
        setMeta(it);
      }
      return it[META].w;
    };
    var onFreeze = function (it) {
      if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
      return it;
    };
    var meta = module.exports = {
      KEY: META,
      NEED: false,
      fastKey: fastKey,
      getWeak: getWeak,
      onFreeze: onFreeze
    };
  });
  var _meta_1 = _meta.KEY;
  var _meta_2 = _meta.NEED;
  var _meta_3 = _meta.fastKey;
  var _meta_4 = _meta.getWeak;
  var _meta_5 = _meta.onFreeze;
  var _validateCollection = function (it, TYPE) {
    if (!_isObject(it) || it._t !== TYPE) throw TypeError("Incompatible receiver, " + TYPE + " required!");
    return it;
  };
  var dP$2 = _objectDp.f;
  var fastKey = _meta.fastKey;
  var SIZE = _descriptors ? "_s" : "size";
  var getEntry = function (that, key) {
    var index = fastKey(key);
    var entry;
    if (index !== "F") return that._i[index];
    for (entry = that._f; entry; entry = entry.n) {
      if (entry.k == key) return entry;
    }
  };
  var _collectionStrong = {
    getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
      var C = wrapper(function (that, iterable) {
        _anInstance(that, C, NAME, "_i");
        that._t = NAME;
        that._i = _objectCreate(null);
        that._f = undefined;
        that._l = undefined;
        that[SIZE] = 0;
        if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
      });
      _redefineAll(C.prototype, {
        clear: function clear() {
          for (var that = _validateCollection(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
            entry.r = true;
            if (entry.p) entry.p = entry.p.n = undefined;
            delete data[entry.i];
          }
          that._f = that._l = undefined;
          that[SIZE] = 0;
        },
        delete: function (key) {
          var that = _validateCollection(this, NAME);
          var entry = getEntry(that, key);
          if (entry) {
            var next = entry.n;
            var prev = entry.p;
            delete that._i[entry.i];
            entry.r = true;
            if (prev) prev.n = next;
            if (next) next.p = prev;
            if (that._f == entry) that._f = next;
            if (that._l == entry) that._l = prev;
            that[SIZE]--;
          }
          return !!entry;
        },
        forEach: function forEach(callbackfn) {
          _validateCollection(this, NAME);
          var f = _ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
          var entry;
          while (entry = entry ? entry.n : this._f) {
            f(entry.v, entry.k, this);
            while (entry && entry.r) entry = entry.p;
          }
        },
        has: function has(key) {
          return !!getEntry(_validateCollection(this, NAME), key);
        }
      });
      if (_descriptors) dP$2(C.prototype, "size", {
        get: function () {
          return _validateCollection(this, NAME)[SIZE];
        }
      });
      return C;
    },
    def: function (that, key, value) {
      var entry = getEntry(that, key);
      var prev, index;
      if (entry) {
        entry.v = value;
      } else {
        that._l = entry = {
          i: index = fastKey(key, true),
          k: key,
          v: value,
          p: prev = that._l,
          n: undefined,
          r: false
        };
        if (!that._f) that._f = entry;
        if (prev) prev.n = entry;
        that[SIZE]++;
        if (index !== "F") that._i[index] = entry;
      }
      return that;
    },
    getEntry: getEntry,
    setStrong: function (C, NAME, IS_MAP) {
      _iterDefine(C, NAME, function (iterated, kind) {
        this._t = _validateCollection(iterated, NAME);
        this._k = kind;
        this._l = undefined;
      }, function () {
        var that = this;
        var kind = that._k;
        var entry = that._l;
        while (entry && entry.r) entry = entry.p;
        if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
          that._t = undefined;
          return _iterStep(1);
        }
        if (kind == "keys") return _iterStep(0, entry.k);
        if (kind == "values") return _iterStep(0, entry.v);
        return _iterStep(0, [entry.k, entry.v]);
      }, IS_MAP ? "entries" : "values", !IS_MAP, true);
      _setSpecies(NAME);
    }
  };
  var f$1 = {}.propertyIsEnumerable;
  var _objectPie = {
    f: f$1
  };
  var gOPD = Object.getOwnPropertyDescriptor;
  var f$2 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
    O = _toIobject(O);
    P = _toPrimitive(P, true);
    if (_ie8DomDefine) try {
      return gOPD(O, P);
    } catch (e) { }
    if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
  };
  var _objectGopd = {
    f: f$2
  };
  var check = function (O, proto) {
    _anObject(O);
    if (!_isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
  };
  var _setProto = {
    set: Object.setPrototypeOf || ("__proto__" in {} ? function (test, buggy, set) {
      try {
        set = _ctx(Function.call, _objectGopd.f(Object.prototype, "__proto__").set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) {
        buggy = true;
      }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto; else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
    check: check
  };
  var setPrototypeOf = _setProto.set;
  var _inheritIfRequired = function (that, target, C) {
    var S = target.constructor;
    var P;
    if (S !== C && typeof S == "function" && (P = S.prototype) !== C.prototype && _isObject(P) && setPrototypeOf) {
      setPrototypeOf(that, P);
    }
    return that;
  };
  var _collection = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
    var Base = _global[NAME];
    var C = Base;
    var ADDER = IS_MAP ? "set" : "add";
    var proto = C && C.prototype;
    var O = {};
    var fixMethod = function (KEY) {
      var fn = proto[KEY];
      _redefine(proto, KEY, KEY == "delete" ? function (a) {
        return IS_WEAK && !_isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == "has" ? function has(a) {
        return IS_WEAK && !_isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == "get" ? function get(a) {
        return IS_WEAK && !_isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == "add" ? function add(a) {
        fn.call(this, a === 0 ? 0 : a);
        return this;
      } : function set(a, b) {
        fn.call(this, a === 0 ? 0 : a, b);
        return this;
      });
    };
    if (typeof C != "function" || !(IS_WEAK || proto.forEach && !_fails(function () {
      new C().entries().next();
    }))) {
      C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
      _redefineAll(C.prototype, methods);
      _meta.NEED = true;
    } else {
      var instance = new C();
      var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
      var THROWS_ON_PRIMITIVES = _fails(function () {
        instance.has(1);
      });
      var ACCEPT_ITERABLES = _iterDetect(function (iter) {
        new C(iter);
      });
      var BUGGY_ZERO = !IS_WEAK && _fails(function () {
        var $instance = new C();
        var index = 5;
        while (index--) $instance[ADDER](index, index);
        return !$instance.has(-0);
      });
      if (!ACCEPT_ITERABLES) {
        C = wrapper(function (target, iterable) {
          _anInstance(target, C, NAME);
          var that = _inheritIfRequired(new Base(), target, C);
          if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
          return that;
        });
        C.prototype = proto;
        proto.constructor = C;
      }
      if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
        fixMethod("delete");
        fixMethod("has");
        IS_MAP && fixMethod("get");
      }
      if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
      if (IS_WEAK && proto.clear) delete proto.clear;
    }
    _setToStringTag(C, NAME);
    O[NAME] = C;
    _export(_export.G + _export.W + _export.F * (C != Base), O);
    if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
    return C;
  };
  var MAP = "Map";
  var es6_map = _collection(MAP, function (get) {
    return function Map() {
      return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
  }, {
    get: function get(key) {
      var entry = _collectionStrong.getEntry(_validateCollection(this, MAP), key);
      return entry && entry.v;
    },
    set: function set(key, value) {
      return _collectionStrong.def(_validateCollection(this, MAP), key === 0 ? 0 : key, value);
    }
  }, _collectionStrong, true);
  var _mathLog1p = Math.log1p || function log1p(x) {
    return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
  };
  var sqrt = Math.sqrt;
  var $acosh = Math.acosh;
  _export(_export.S + _export.F * !($acosh && Math.floor($acosh(Number.MAX_VALUE)) == 710 && $acosh(Infinity) == Infinity), "Math", {
    acosh: function acosh(x) {
      return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : _mathLog1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
    }
  });
  var $asinh = Math.asinh;
  function asinh(x) {
    return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
  }
  _export(_export.S + _export.F * !($asinh && 1 / $asinh(0) > 0), "Math", {
    asinh: asinh
  });
  var $atanh = Math.atanh;
  _export(_export.S + _export.F * !($atanh && 1 / $atanh(-0) < 0), "Math", {
    atanh: function atanh(x) {
      return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
    }
  });
  var _mathSign = Math.sign || function sign(x) {
    return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
  };
  _export(_export.S, "Math", {
    cbrt: function cbrt(x) {
      return _mathSign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
    }
  });
  _export(_export.S, "Math", {
    clz32: function clz32(x) {
      return (x >>>= 0) ? 31 - Math.floor(Math.log(x + .5) * Math.LOG2E) : 32;
    }
  });
  var exp = Math.exp;
  _export(_export.S, "Math", {
    cosh: function cosh(x) {
      return (exp(x = +x) + exp(-x)) / 2;
    }
  });
  var $expm1 = Math.expm1;
  var _mathExpm1 = !$expm1 || $expm1(10) > 22025.465794806718 || $expm1(10) < 22025.465794806718 || $expm1(-2e-17) != -2e-17 ? function expm1(x) {
    return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
  } : $expm1;
  _export(_export.S + _export.F * (_mathExpm1 != Math.expm1), "Math", {
    expm1: _mathExpm1
  });
  var pow = Math.pow;
  var EPSILON = pow(2, -52);
  var EPSILON32 = pow(2, -23);
  var MAX32 = pow(2, 127) * (2 - EPSILON32);
  var MIN32 = pow(2, -126);
  var roundTiesToEven = function (n) {
    return n + 1 / EPSILON - 1 / EPSILON;
  };
  var _mathFround = Math.fround || function fround(x) {
    var $abs = Math.abs(x);
    var $sign = _mathSign(x);
    var a, result;
    if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
    a = (1 + EPSILON32 / EPSILON) * $abs;
    result = a - (a - $abs);
    if (result > MAX32 || result != result) return $sign * Infinity;
    return $sign * result;
  };
  _export(_export.S, "Math", {
    fround: _mathFround
  });
  var abs = Math.abs;
  _export(_export.S, "Math", {
    hypot: function hypot(value1, value2) {
      var sum = 0;
      var i = 0;
      var aLen = arguments.length;
      var larg = 0;
      var arg, div;
      while (i < aLen) {
        arg = abs(arguments[i++]);
        if (larg < arg) {
          div = larg / arg;
          sum = sum * div * div + 1;
          larg = arg;
        } else if (arg > 0) {
          div = arg / larg;
          sum += div * div;
        } else sum += arg;
      }
      return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
    }
  });
  var $imul = Math.imul;
  _export(_export.S + _export.F * _fails(function () {
    return $imul(4294967295, 5) != -5 || $imul.length != 2;
  }), "Math", {
    imul: function imul(x, y) {
      var UINT16 = 65535;
      var xn = +x;
      var yn = +y;
      var xl = UINT16 & xn;
      var yl = UINT16 & yn;
      return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
    }
  });
  _export(_export.S, "Math", {
    log1p: _mathLog1p
  });
  _export(_export.S, "Math", {
    log10: function log10(x) {
      return Math.log(x) * Math.LOG10E;
    }
  });
  _export(_export.S, "Math", {
    log2: function log2(x) {
      return Math.log(x) / Math.LN2;
    }
  });
  _export(_export.S, "Math", {
    sign: _mathSign
  });
  var exp$1 = Math.exp;
  _export(_export.S + _export.F * _fails(function () {
    return !Math.sinh(-2e-17) != -2e-17;
  }), "Math", {
    sinh: function sinh(x) {
      return Math.abs(x = +x) < 1 ? (_mathExpm1(x) - _mathExpm1(-x)) / 2 : (exp$1(x - 1) - exp$1(-x - 1)) * (Math.E / 2);
    }
  });
  var exp$2 = Math.exp;
  _export(_export.S, "Math", {
    tanh: function tanh(x) {
      var a = _mathExpm1(x = +x);
      var b = _mathExpm1(-x);
      return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp$2(x) + exp$2(-x));
    }
  });
  _export(_export.S, "Math", {
    trunc: function trunc(it) {
      return (it > 0 ? Math.floor : Math.ceil)(it);
    }
  });
  var hiddenKeys = _enumBugKeys.concat("length", "prototype");
  var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return _objectKeysInternal(O, hiddenKeys);
  };
  var _objectGopn = {
    f: f$3
  };
  var _stringWs = "\t\n\v\f\r   ᠎    " + "         　\u2028\u2029\ufeff";
  var space = "[" + _stringWs + "]";
  var non = "​";
  var ltrim = RegExp("^" + space + space + "*");
  var rtrim = RegExp(space + space + "*$");
  var exporter = function (KEY, exec, ALIAS) {
    var exp = {};
    var FORCE = _fails(function () {
      return !!_stringWs[KEY]() || non[KEY]() != non;
    });
    var fn = exp[KEY] = FORCE ? exec(trim) : _stringWs[KEY];
    if (ALIAS) exp[ALIAS] = fn;
    _export(_export.P + _export.F * FORCE, "String", exp);
  };
  var trim = exporter.trim = function (string, TYPE) {
    string = String(_defined(string));
    if (TYPE & 1) string = string.replace(ltrim, "");
    if (TYPE & 2) string = string.replace(rtrim, "");
    return string;
  };
  var _stringTrim = exporter;
  var gOPN = _objectGopn.f;
  var gOPD$1 = _objectGopd.f;
  var dP$3 = _objectDp.f;
  var $trim = _stringTrim.trim;
  var NUMBER$1 = "Number";
  var $Number = _global[NUMBER$1];
  var Base = $Number;
  var proto$1 = $Number.prototype;
  var BROKEN_COF = _cof(_objectCreate(proto$1)) == NUMBER$1;
  var TRIM = "trim" in String.prototype;
  var toNumber = function (argument) {
    var it = _toPrimitive(argument, false);
    if (typeof it == "string" && it.length > 2) {
      it = TRIM ? it.trim() : $trim(it, 3);
      var first = it.charCodeAt(0);
      var third, radix, maxCode;
      if (first === 43 || first === 45) {
        third = it.charCodeAt(2);
        if (third === 88 || third === 120) return NaN;
      } else if (first === 48) {
        switch (it.charCodeAt(1)) {
          case 66:
          case 98:
            radix = 2;
            maxCode = 49;
            break;

          case 79:
          case 111:
            radix = 8;
            maxCode = 55;
            break;

          default:
            return +it;
        }
        for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
          code = digits.charCodeAt(i);
          if (code < 48 || code > maxCode) return NaN;
        }
        return parseInt(digits, radix);
      }
    }
    return +it;
  };
  if (!$Number(" 0o1") || !$Number("0b1") || $Number("+0x1")) {
    $Number = function Number(value) {
      var it = arguments.length < 1 ? 0 : value;
      var that = this;
      return that instanceof $Number && (BROKEN_COF ? _fails(function () {
        proto$1.valueOf.call(that);
      }) : _cof(that) != NUMBER$1) ? _inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
    };
    for (var keys = _descriptors ? gOPN(Base) : ("MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY," + "EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER," + "MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger").split(","), j = 0, key; keys.length > j; j++) {
      if (_has(Base, key = keys[j]) && !_has($Number, key)) {
        dP$3($Number, key, gOPD$1(Base, key));
      }
    }
    $Number.prototype = proto$1;
    proto$1.constructor = $Number;
    _redefine(_global, NUMBER$1, $Number);
  }
  _export(_export.S, "Number", {
    EPSILON: Math.pow(2, -52)
  });
  var _isFinite = _global.isFinite;
  _export(_export.S, "Number", {
    isFinite: function isFinite(it) {
      return typeof it == "number" && _isFinite(it);
    }
  });
  var floor$1 = Math.floor;
  var _isInteger = function isInteger(it) {
    return !_isObject(it) && isFinite(it) && floor$1(it) === it;
  };
  _export(_export.S, "Number", {
    isInteger: _isInteger
  });
  _export(_export.S, "Number", {
    isNaN: function isNaN(number) {
      return number != number;
    }
  });
  var abs$1 = Math.abs;
  _export(_export.S, "Number", {
    isSafeInteger: function isSafeInteger(number) {
      return _isInteger(number) && abs$1(number) <= 9007199254740991;
    }
  });
  _export(_export.S, "Number", {
    MAX_SAFE_INTEGER: 9007199254740991
  });
  _export(_export.S, "Number", {
    MIN_SAFE_INTEGER: -9007199254740991
  });
  var $parseFloat = _global.parseFloat;
  var $trim$1 = _stringTrim.trim;
  var _parseFloat = 1 / $parseFloat(_stringWs + "-0") !== -Infinity ? function parseFloat(str) {
    var string = $trim$1(String(str), 3);
    var result = $parseFloat(string);
    return result === 0 && string.charAt(0) == "-" ? -0 : result;
  } : $parseFloat;
  _export(_export.S + _export.F * (Number.parseFloat != _parseFloat), "Number", {
    parseFloat: _parseFloat
  });
  var $parseInt = _global.parseInt;
  var $trim$2 = _stringTrim.trim;
  var hex = /^[-+]?0[xX]/;
  var _parseInt = $parseInt(_stringWs + "08") !== 8 || $parseInt(_stringWs + "0x16") !== 22 ? function parseInt(str, radix) {
    var string = $trim$2(String(str), 3);
    return $parseInt(string, radix >>> 0 || (hex.test(string) ? 16 : 10));
  } : $parseInt;
  _export(_export.S + _export.F * (Number.parseInt != _parseInt), "Number", {
    parseInt: _parseInt
  });
  var f$4 = Object.getOwnPropertySymbols;
  var _objectGops = {
    f: f$4
  };
  var $assign = Object.assign;
  var _objectAssign = !$assign || _fails(function () {
    var A = {};
    var B = {};
    var S = Symbol();
    var K = "abcdefghijklmnopqrst";
    A[S] = 7;
    K.split("").forEach(function (k) {
      B[k] = k;
    });
    return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join("") != K;
  }) ? function assign(target, source) {
    var T = _toObject(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = _objectGops.f;
    var isEnum = _objectPie.f;
    while (aLen > index) {
      var S = _iobject(arguments[index++]);
      var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
      var length = keys.length;
      var j = 0;
      var key;
      while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
    }
    return T;
  } : $assign;
  _export(_export.S + _export.F, "Object", {
    assign: _objectAssign
  });
  var _objectForcedPam = _library || !_fails(function () {
    var K = Math.random();
    __defineSetter__.call(null, K, function () { });
    delete _global[K];
  });
  _descriptors && _export(_export.P + _objectForcedPam, "Object", {
    __defineGetter__: function __defineGetter__(P, getter) {
      _objectDp.f(_toObject(this), P, {
        get: _aFunction(getter),
        enumerable: true,
        configurable: true
      });
    }
  });
  _descriptors && _export(_export.P + _objectForcedPam, "Object", {
    __defineSetter__: function __defineSetter__(P, setter) {
      _objectDp.f(_toObject(this), P, {
        set: _aFunction(setter),
        enumerable: true,
        configurable: true
      });
    }
  });
  var isEnum = _objectPie.f;
  var _objectToArray = function (isEntries) {
    return function (it) {
      var O = _toIobject(it);
      var keys = _objectKeys(O);
      var length = keys.length;
      var i = 0;
      var result = [];
      var key;
      while (length > i) if (isEnum.call(O, key = keys[i++])) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
      return result;
    };
  };
  var $entries = _objectToArray(true);
  _export(_export.S, "Object", {
    entries: function entries(it) {
      return $entries(it);
    }
  });
  var _objectSap = function (KEY, exec) {
    var fn = (_core.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    _export(_export.S + _export.F * _fails(function () {
      fn(1);
    }), "Object", exp);
  };
  var meta = _meta.onFreeze;
  _objectSap("freeze", function ($freeze) {
    return function freeze(it) {
      return $freeze && _isObject(it) ? $freeze(meta(it)) : it;
    };
  });
  var $getOwnPropertyDescriptor = _objectGopd.f;
  _objectSap("getOwnPropertyDescriptor", function () {
    return function getOwnPropertyDescriptor(it, key) {
      return $getOwnPropertyDescriptor(_toIobject(it), key);
    };
  });
  var Reflect$1 = _global.Reflect;
  var _ownKeys = Reflect$1 && Reflect$1.ownKeys || function ownKeys(it) {
    var keys = _objectGopn.f(_anObject(it));
    var getSymbols = _objectGops.f;
    return getSymbols ? keys.concat(getSymbols(it)) : keys;
  };
  _export(_export.S, "Object", {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
      var O = _toIobject(object);
      var getDesc = _objectGopd.f;
      var keys = _ownKeys(O);
      var result = {};
      var i = 0;
      var key, desc;
      while (keys.length > i) {
        desc = getDesc(O, key = keys[i++]);
        if (desc !== undefined) _createProperty(result, key, desc);
      }
      return result;
    }
  });
  var gOPN$1 = _objectGopn.f;
  var toString$1 = {}.toString;
  var windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
  var getWindowNames = function (it) {
    try {
      return gOPN$1(it);
    } catch (e) {
      return windowNames.slice();
    }
  };
  var f$5 = function getOwnPropertyNames(it) {
    return windowNames && toString$1.call(it) == "[object Window]" ? getWindowNames(it) : gOPN$1(_toIobject(it));
  };
  var _objectGopnExt = {
    f: f$5
  };
  _objectSap("getOwnPropertyNames", function () {
    return _objectGopnExt.f;
  });
  _objectSap("getPrototypeOf", function () {
    return function getPrototypeOf(it) {
      return _objectGpo(_toObject(it));
    };
  });
  var getOwnPropertyDescriptor = _objectGopd.f;
  _descriptors && _export(_export.P + _objectForcedPam, "Object", {
    __lookupGetter__: function __lookupGetter__(P) {
      var O = _toObject(this);
      var K = _toPrimitive(P, true);
      var D;
      do {
        if (D = getOwnPropertyDescriptor(O, K)) return D.get;
      } while (O = _objectGpo(O));
    }
  });
  var getOwnPropertyDescriptor$1 = _objectGopd.f;
  _descriptors && _export(_export.P + _objectForcedPam, "Object", {
    __lookupSetter__: function __lookupSetter__(P) {
      var O = _toObject(this);
      var K = _toPrimitive(P, true);
      var D;
      do {
        if (D = getOwnPropertyDescriptor$1(O, K)) return D.set;
      } while (O = _objectGpo(O));
    }
  });
  var meta$1 = _meta.onFreeze;
  _objectSap("preventExtensions", function ($preventExtensions) {
    return function preventExtensions(it) {
      return $preventExtensions && _isObject(it) ? $preventExtensions(meta$1(it)) : it;
    };
  });
  var _sameValue = Object.is || function is(x, y) {
    return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
  };
  _export(_export.S, "Object", {
    is: _sameValue
  });
  _objectSap("isFrozen", function ($isFrozen) {
    return function isFrozen(it) {
      return _isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
    };
  });
  _objectSap("isSealed", function ($isSealed) {
    return function isSealed(it) {
      return _isObject(it) ? $isSealed ? $isSealed(it) : false : true;
    };
  });
  _objectSap("isExtensible", function ($isExtensible) {
    return function isExtensible(it) {
      return _isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
    };
  });
  _objectSap("keys", function () {
    return function keys(it) {
      return _objectKeys(_toObject(it));
    };
  });
  var meta$2 = _meta.onFreeze;
  _objectSap("seal", function ($seal) {
    return function seal(it) {
      return $seal && _isObject(it) ? $seal(meta$2(it)) : it;
    };
  });
  _export(_export.S, "Object", {
    setPrototypeOf: _setProto.set
  });
  var $values = _objectToArray(false);
  _export(_export.S, "Object", {
    values: function values(it) {
      return $values(it);
    }
  });
  var SPECIES$2 = _wks("species");
  var _speciesConstructor = function (O, D) {
    var C = _anObject(O).constructor;
    var S;
    return C === undefined || (S = _anObject(C)[SPECIES$2]) == undefined ? D : _aFunction(S);
  };
  var _invoke = function (fn, args, that) {
    var un = that === undefined;
    switch (args.length) {
      case 0:
        return un ? fn() : fn.call(that);

      case 1:
        return un ? fn(args[0]) : fn.call(that, args[0]);

      case 2:
        return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);

      case 3:
        return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);

      case 4:
        return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }
    return fn.apply(that, args);
  };
  var process = _global.process;
  var setTask = _global.setImmediate;
  var clearTask = _global.clearImmediate;
  var MessageChannel = _global.MessageChannel;
  var Dispatch = _global.Dispatch;
  var counter = 0;
  var queue = {};
  var ONREADYSTATECHANGE = "onreadystatechange";
  var defer, channel, port;
  var run = function () {
    var id = +this;
    if (queue.hasOwnProperty(id)) {
      var fn = queue[id];
      delete queue[id];
      fn();
    }
  };
  var listener = function (event) {
    run.call(event.data);
  };
  if (!setTask || !clearTask) {
    setTask = function setImmediate(fn) {
      var args = [];
      var i = 1;
      while (arguments.length > i) args.push(arguments[i++]);
      queue[++counter] = function () {
        _invoke(typeof fn == "function" ? fn : Function(fn), args);
      };
      defer(counter);
      return counter;
    };
    clearTask = function clearImmediate(id) {
      delete queue[id];
    };
    if (_cof(process) == "process") {
      defer = function (id) {
        process.nextTick(_ctx(run, id, 1));
      };
    } else if (Dispatch && Dispatch.now) {
      defer = function (id) {
        Dispatch.now(_ctx(run, id, 1));
      };
    } else if (MessageChannel) {
      channel = new MessageChannel();
      port = channel.port2;
      channel.port1.onmessage = listener;
      defer = _ctx(port.postMessage, port, 1);
    } else if (_global.addEventListener && typeof postMessage == "function" && !_global.importScripts) {
      defer = function (id) {
        _global.postMessage(id + "", "*");
      };
      _global.addEventListener("message", listener, false);
    } else if (ONREADYSTATECHANGE in _domCreate("script")) {
      defer = function (id) {
        _html.appendChild(_domCreate("script"))[ONREADYSTATECHANGE] = function () {
          _html.removeChild(this);
          run.call(id);
        };
      };
    } else {
      defer = function (id) {
        setTimeout(_ctx(run, id, 1), 0);
      };
    }
  }
  var _task = {
    set: setTask,
    clear: clearTask
  };
  var macrotask = _task.set;
  var Observer = _global.MutationObserver || _global.WebKitMutationObserver;
  var process$1 = _global.process;
  var Promise$1 = _global.Promise;
  var isNode = _cof(process$1) == "process";
  var _microtask = function () {
    var head, last, notify;
    var flush = function () {
      var parent, fn;
      if (isNode && (parent = process$1.domain)) parent.exit();
      while (head) {
        fn = head.fn;
        head = head.next;
        try {
          fn();
        } catch (e) {
          if (head) notify(); else last = undefined;
          throw e;
        }
      }
      last = undefined;
      if (parent) parent.enter();
    };
    if (isNode) {
      notify = function () {
        process$1.nextTick(flush);
      };
    } else if (Observer && !(_global.navigator && _global.navigator.standalone)) {
      var toggle = true;
      var node = document.createTextNode("");
      new Observer(flush).observe(node, {
        characterData: true
      });
      notify = function () {
        node.data = toggle = !toggle;
      };
    } else if (Promise$1 && Promise$1.resolve) {
      var promise = Promise$1.resolve(undefined);
      notify = function () {
        promise.then(flush);
      };
    } else {
      notify = function () {
        macrotask.call(_global, flush);
      };
    }
    return function (fn) {
      var task = {
        fn: fn,
        next: undefined
      };
      if (last) last.next = task;
      if (!head) {
        head = task;
        notify();
      }
      last = task;
    };
  };
  function PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function ($$resolve, $$reject) {
      if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
      resolve = $$resolve;
      reject = $$reject;
    });
    this.resolve = _aFunction(resolve);
    this.reject = _aFunction(reject);
  }
  var f$6 = function (C) {
    return new PromiseCapability(C);
  };
  var _newPromiseCapability = {
    f: f$6
  };
  var _perform = function (exec) {
    try {
      return {
        e: false,
        v: exec()
      };
    } catch (e) {
      return {
        e: true,
        v: e
      };
    }
  };
  var navigator$1 = _global.navigator;
  var _userAgent = navigator$1 && navigator$1.userAgent || "";
  var _promiseResolve = function (C, x) {
    _anObject(C);
    if (_isObject(x) && x.constructor === C) return x;
    var promiseCapability = _newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
  };
  var task = _task.set;
  var microtask = _microtask();
  var PROMISE = "Promise";
  var TypeError$1 = _global.TypeError;
  var process$2 = _global.process;
  var versions = process$2 && process$2.versions;
  var v8 = versions && versions.v8 || "";
  var $Promise = _global[PROMISE];
  var isNode$1 = _classof(process$2) == "process";
  var empty = function () { };
  var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
  var newPromiseCapability = newGenericPromiseCapability = _newPromiseCapability.f;
  var USE_NATIVE = !!function () {
    try {
      var promise = $Promise.resolve(1);
      var FakePromise = (promise.constructor = {})[_wks("species")] = function (exec) {
        exec(empty, empty);
      };
      return (isNode$1 || typeof PromiseRejectionEvent == "function") && promise.then(empty) instanceof FakePromise && v8.indexOf("6.6") !== 0 && _userAgent.indexOf("Chrome/66") === -1;
    } catch (e) { }
  }();
  var isThenable = function (it) {
    var then;
    return _isObject(it) && typeof (then = it.then) == "function" ? then : false;
  };
  var notify = function (promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    microtask(function () {
      var value = promise._v;
      var ok = promise._s == 1;
      var i = 0;
      var run = function (reaction) {
        var handler = ok ? reaction.ok : reaction.fail;
        var resolve = reaction.resolve;
        var reject = reaction.reject;
        var domain = reaction.domain;
        var result, then, exited;
        try {
          if (handler) {
            if (!ok) {
              if (promise._h == 2) onHandleUnhandled(promise);
              promise._h = 1;
            }
            if (handler === true) result = value; else {
              if (domain) domain.enter();
              result = handler(value);
              if (domain) {
                domain.exit();
                exited = true;
              }
            }
            if (result === reaction.promise) {
              reject(TypeError$1("Promise-chain cycle"));
            } else if (then = isThenable(result)) {
              then.call(result, resolve, reject);
            } else resolve(result);
          } else reject(value);
        } catch (e) {
          if (domain && !exited) domain.exit();
          reject(e);
        }
      };
      while (chain.length > i) run(chain[i++]);
      promise._c = [];
      promise._n = false;
      if (isReject && !promise._h) onUnhandled(promise);
    });
  };
  var onUnhandled = function (promise) {
    task.call(_global, function () {
      var value = promise._v;
      var unhandled = isUnhandled(promise);
      var result, handler, console;
      if (unhandled) {
        result = _perform(function () {
          if (isNode$1) {
            process$2.emit("unhandledRejection", value, promise);
          } else if (handler = _global.onunhandledrejection) {
            handler({
              promise: promise,
              reason: value
            });
          } else if ((console = _global.console) && console.error) {
            console.error("Unhandled promise rejection", value);
          }
        });
        promise._h = isNode$1 || isUnhandled(promise) ? 2 : 1;
      }
      promise._a = undefined;
      if (unhandled && result.e) throw result.v;
    });
  };
  var isUnhandled = function (promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
  };
  var onHandleUnhandled = function (promise) {
    task.call(_global, function () {
      var handler;
      if (isNode$1) {
        process$2.emit("rejectionHandled", promise);
      } else if (handler = _global.onrejectionhandled) {
        handler({
          promise: promise,
          reason: promise._v
        });
      }
    });
  };
  var $reject = function (value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise;
    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    notify(promise, true);
  };
  var $resolve = function (value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise;
    try {
      if (promise === value) throw TypeError$1("Promise can't be resolved itself");
      if (then = isThenable(value)) {
        microtask(function () {
          var wrapper = {
            _w: promise,
            _d: false
          };
          try {
            then.call(value, _ctx($resolve, wrapper, 1), _ctx($reject, wrapper, 1));
          } catch (e) {
            $reject.call(wrapper, e);
          }
        });
      } else {
        promise._v = value;
        promise._s = 1;
        notify(promise, false);
      }
    } catch (e) {
      $reject.call({
        _w: promise,
        _d: false
      }, e);
    }
  };
  if (!USE_NATIVE) {
    $Promise = function Promise(executor) {
      _anInstance(this, $Promise, PROMISE, "_h");
      _aFunction(executor);
      Internal.call(this);
      try {
        executor(_ctx($resolve, this, 1), _ctx($reject, this, 1));
      } catch (err) {
        $reject.call(this, err);
      }
    };
    Internal = function Promise(executor) {
      this._c = [];
      this._a = undefined;
      this._s = 0;
      this._d = false;
      this._v = undefined;
      this._h = 0;
      this._n = false;
    };
    Internal.prototype = _redefineAll($Promise.prototype, {
      then: function then(onFulfilled, onRejected) {
        var reaction = newPromiseCapability(_speciesConstructor(this, $Promise));
        reaction.ok = typeof onFulfilled == "function" ? onFulfilled : true;
        reaction.fail = typeof onRejected == "function" && onRejected;
        reaction.domain = isNode$1 ? process$2.domain : undefined;
        this._c.push(reaction);
        if (this._a) this._a.push(reaction);
        if (this._s) notify(this, false);
        return reaction.promise;
      },
      catch: function (onRejected) {
        return this.then(undefined, onRejected);
      }
    });
    OwnPromiseCapability = function () {
      var promise = new Internal();
      this.promise = promise;
      this.resolve = _ctx($resolve, promise, 1);
      this.reject = _ctx($reject, promise, 1);
    };
    _newPromiseCapability.f = newPromiseCapability = function (C) {
      return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
    };
  }
  _export(_export.G + _export.W + _export.F * !USE_NATIVE, {
    Promise: $Promise
  });
  _setToStringTag($Promise, PROMISE);
  _setSpecies(PROMISE);
  Wrapper = _core[PROMISE];
  _export(_export.S + _export.F * !USE_NATIVE, PROMISE, {
    reject: function reject(r) {
      var capability = newPromiseCapability(this);
      var $$reject = capability.reject;
      $$reject(r);
      return capability.promise;
    }
  });
  _export(_export.S + _export.F * (_library || !USE_NATIVE), PROMISE, {
    resolve: function resolve(x) {
      return _promiseResolve(_library && this === Wrapper ? $Promise : this, x);
    }
  });
  _export(_export.S + _export.F * !(USE_NATIVE && _iterDetect(function (iter) {
    $Promise.all(iter)["catch"](empty);
  })), PROMISE, {
    all: function all(iterable) {
      var C = this;
      var capability = newPromiseCapability(C);
      var resolve = capability.resolve;
      var reject = capability.reject;
      var result = _perform(function () {
        var values = [];
        var index = 0;
        var remaining = 1;
        _forOf(iterable, false, function (promise) {
          var $index = index++;
          var alreadyCalled = false;
          values.push(undefined);
          remaining++;
          C.resolve(promise).then(function (value) {
            if (alreadyCalled) return;
            alreadyCalled = true;
            values[$index] = value;
            --remaining || resolve(values);
          }, reject);
        });
        --remaining || resolve(values);
      });
      if (result.e) reject(result.v);
      return capability.promise;
    },
    race: function race(iterable) {
      var C = this;
      var capability = newPromiseCapability(C);
      var reject = capability.reject;
      var result = _perform(function () {
        _forOf(iterable, false, function (promise) {
          C.resolve(promise).then(capability.resolve, reject);
        });
      });
      if (result.e) reject(result.v);
      return capability.promise;
    }
  });
  _export(_export.P + _export.R, "Promise", {
    finally: function (onFinally) {
      var C = _speciesConstructor(this, _core.Promise || _global.Promise);
      var isFunction = typeof onFinally == "function";
      return this.then(isFunction ? function (x) {
        return _promiseResolve(C, onFinally()).then(function () {
          return x;
        });
      } : onFinally, isFunction ? function (e) {
        return _promiseResolve(C, onFinally()).then(function () {
          throw e;
        });
      } : onFinally);
    }
  });
  var rApply = (_global.Reflect || {}).apply;
  var fApply = Function.apply;
  _export(_export.S + _export.F * !_fails(function () {
    rApply(function () { });
  }), "Reflect", {
    apply: function apply(target, thisArgument, argumentsList) {
      var T = _aFunction(target);
      var L = _anObject(argumentsList);
      return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
    }
  });
  var arraySlice = [].slice;
  var factories = {};
  var construct = function (F, len, args) {
    if (!(len in factories)) {
      for (var n = [], i = 0; i < len; i++) n[i] = "a[" + i + "]";
      factories[len] = Function("F,a", "return new F(" + n.join(",") + ")");
    }
    return factories[len](F, args);
  };
  var _bind = Function.bind || function bind(that) {
    var fn = _aFunction(this);
    var partArgs = arraySlice.call(arguments, 1);
    var bound = function () {
      var args = partArgs.concat(arraySlice.call(arguments));
      return this instanceof bound ? construct(fn, args.length, args) : _invoke(fn, args, that);
    };
    if (_isObject(fn.prototype)) bound.prototype = fn.prototype;
    return bound;
  };
  var rConstruct = (_global.Reflect || {}).construct;
  var NEW_TARGET_BUG = _fails(function () {
    function F() { }
    return !(rConstruct(function () { }, [], F) instanceof F);
  });
  var ARGS_BUG = !_fails(function () {
    rConstruct(function () { });
  });
  _export(_export.S + _export.F * (NEW_TARGET_BUG || ARGS_BUG), "Reflect", {
    construct: function construct(Target, args) {
      _aFunction(Target);
      _anObject(args);
      var newTarget = arguments.length < 3 ? Target : _aFunction(arguments[2]);
      if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
      if (Target == newTarget) {
        switch (args.length) {
          case 0:
            return new Target();

          case 1:
            return new Target(args[0]);

          case 2:
            return new Target(args[0], args[1]);

          case 3:
            return new Target(args[0], args[1], args[2]);

          case 4:
            return new Target(args[0], args[1], args[2], args[3]);
        }
        var $args = [null];
        $args.push.apply($args, args);
        return new (_bind.apply(Target, $args))();
      }
      var proto = newTarget.prototype;
      var instance = _objectCreate(_isObject(proto) ? proto : Object.prototype);
      var result = Function.apply.call(Target, instance, args);
      return _isObject(result) ? result : instance;
    }
  });
  _export(_export.S + _export.F * _fails(function () {
    Reflect.defineProperty(_objectDp.f({}, 1, {
      value: 1
    }), 1, {
      value: 2
    });
  }), "Reflect", {
    defineProperty: function defineProperty(target, propertyKey, attributes) {
      _anObject(target);
      propertyKey = _toPrimitive(propertyKey, true);
      _anObject(attributes);
      try {
        _objectDp.f(target, propertyKey, attributes);
        return true;
      } catch (e) {
        return false;
      }
    }
  });
  var gOPD$2 = _objectGopd.f;
  _export(_export.S, "Reflect", {
    deleteProperty: function deleteProperty(target, propertyKey) {
      var desc = gOPD$2(_anObject(target), propertyKey);
      return desc && !desc.configurable ? false : delete target[propertyKey];
    }
  });
  function get(target, propertyKey) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var desc, proto;
    if (_anObject(target) === receiver) return target[propertyKey];
    if (desc = _objectGopd.f(target, propertyKey)) return _has(desc, "value") ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
    if (_isObject(proto = _objectGpo(target))) return get(proto, propertyKey, receiver);
  }
  _export(_export.S, "Reflect", {
    get: get
  });
  _export(_export.S, "Reflect", {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
      return _objectGopd.f(_anObject(target), propertyKey);
    }
  });
  _export(_export.S, "Reflect", {
    getPrototypeOf: function getPrototypeOf(target) {
      return _objectGpo(_anObject(target));
    }
  });
  _export(_export.S, "Reflect", {
    has: function has(target, propertyKey) {
      return propertyKey in target;
    }
  });
  var $isExtensible = Object.isExtensible;
  _export(_export.S, "Reflect", {
    isExtensible: function isExtensible(target) {
      _anObject(target);
      return $isExtensible ? $isExtensible(target) : true;
    }
  });
  _export(_export.S, "Reflect", {
    ownKeys: _ownKeys
  });
  var $preventExtensions = Object.preventExtensions;
  _export(_export.S, "Reflect", {
    preventExtensions: function preventExtensions(target) {
      _anObject(target);
      try {
        if ($preventExtensions) $preventExtensions(target);
        return true;
      } catch (e) {
        return false;
      }
    }
  });
  function set(target, propertyKey, V) {
    var receiver = arguments.length < 4 ? target : arguments[3];
    var ownDesc = _objectGopd.f(_anObject(target), propertyKey);
    var existingDescriptor, proto;
    if (!ownDesc) {
      if (_isObject(proto = _objectGpo(target))) {
        return set(proto, propertyKey, V, receiver);
      }
      ownDesc = _propertyDesc(0);
    }
    if (_has(ownDesc, "value")) {
      if (ownDesc.writable === false || !_isObject(receiver)) return false;
      if (existingDescriptor = _objectGopd.f(receiver, propertyKey)) {
        if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
        existingDescriptor.value = V;
        _objectDp.f(receiver, propertyKey, existingDescriptor);
      } else _objectDp.f(receiver, propertyKey, _propertyDesc(0, V));
      return true;
    }
    return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
  }
  _export(_export.S, "Reflect", {
    set: set
  });
  if (_setProto) _export(_export.S, "Reflect", {
    setPrototypeOf: function setPrototypeOf(target, proto) {
      _setProto.check(target, proto);
      try {
        _setProto.set(target, proto);
        return true;
      } catch (e) {
        return false;
      }
    }
  });
  var MATCH = _wks("match");
  var _isRegexp = function (it) {
    var isRegExp;
    return _isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : _cof(it) == "RegExp");
  };
  var _flags = function () {
    var that = _anObject(this);
    var result = "";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.unicode) result += "u";
    if (that.sticky) result += "y";
    return result;
  };
  var dP$4 = _objectDp.f;
  var gOPN$2 = _objectGopn.f;
  var $RegExp = _global.RegExp;
  var Base$1 = $RegExp;
  var proto$2 = $RegExp.prototype;
  var re1 = /a/g;
  var re2 = /a/g;
  var CORRECT_NEW = new $RegExp(re1) !== re1;
  if (_descriptors && (!CORRECT_NEW || _fails(function () {
    re2[_wks("match")] = false;
    return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, "i") != "/a/i";
  }))) {
    $RegExp = function RegExp(p, f) {
      var tiRE = this instanceof $RegExp;
      var piRE = _isRegexp(p);
      var fiU = f === undefined;
      return !tiRE && piRE && p.constructor === $RegExp && fiU ? p : _inheritIfRequired(CORRECT_NEW ? new Base$1(piRE && !fiU ? p.source : p, f) : Base$1((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? _flags.call(p) : f), tiRE ? this : proto$2, $RegExp);
    };
    var proxy = function (key) {
      key in $RegExp || dP$4($RegExp, key, {
        configurable: true,
        get: function () {
          return Base$1[key];
        },
        set: function (it) {
          Base$1[key] = it;
        }
      });
    };
    for (var keys$1 = gOPN$2(Base$1), i = 0; keys$1.length > i;) proxy(keys$1[i++]);
    proto$2.constructor = $RegExp;
    $RegExp.prototype = proto$2;
    _redefine(_global, "RegExp", $RegExp);
  }
  _setSpecies("RegExp");
  if (_descriptors && /./g.flags != "g") _objectDp.f(RegExp.prototype, "flags", {
    configurable: true,
    get: _flags
  });
  var _fixReWks = function (KEY, length, exec) {
    var SYMBOL = _wks(KEY);
    var fns = exec(_defined, SYMBOL, ""[KEY]);
    var strfn = fns[0];
    var rxfn = fns[1];
    if (_fails(function () {
      var O = {};
      O[SYMBOL] = function () {
        return 7;
      };
      return ""[KEY](O) != 7;
    })) {
      _redefine(String.prototype, KEY, strfn);
      _hide(RegExp.prototype, SYMBOL, length == 2 ? function (string, arg) {
        return rxfn.call(string, this, arg);
      } : function (string) {
        return rxfn.call(string, this);
      });
    }
  };
  _fixReWks("match", 1, function (defined, MATCH, $match) {
    return [function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    }, $match];
  });
  _fixReWks("replace", 2, function (defined, REPLACE, $replace) {
    return [function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
    }, $replace];
  });
  _fixReWks("split", 2, function (defined, SPLIT, $split) {
    var isRegExp = _isRegexp;
    var _split = $split;
    var $push = [].push;
    var $SPLIT = "split";
    var LENGTH = "length";
    var LAST_INDEX = "lastIndex";
    if ("abbc"[$SPLIT](/(b)*/)[1] == "c" || "test"[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || "ab"[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || "."[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || "."[$SPLIT](/()()/)[LENGTH] > 1 || ""[$SPLIT](/.?/)[LENGTH]) {
      var NPCG = /()??/.exec("")[1] === undefined;
      $split = function (separator, limit) {
        var string = String(this);
        if (separator === undefined && limit === 0) return [];
        if (!isRegExp(separator)) return _split.call(string, separator, limit);
        var output = [];
        var flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.unicode ? "u" : "") + (separator.sticky ? "y" : "");
        var lastLastIndex = 0;
        var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
        var separatorCopy = new RegExp(separator.source, flags + "g");
        var separator2, match, lastIndex, lastLength, i;
        if (!NPCG) separator2 = new RegExp("^" + separatorCopy.source + "$(?!\\s)", flags);
        while (match = separatorCopy.exec(string)) {
          lastIndex = match.index + match[0][LENGTH];
          if (lastIndex > lastLastIndex) {
            output.push(string.slice(lastLastIndex, match.index));
            if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
              for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
            });
            if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
            lastLength = match[0][LENGTH];
            lastLastIndex = lastIndex;
            if (output[LENGTH] >= splitLimit) break;
          }
          if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++;
        }
        if (lastLastIndex === string[LENGTH]) {
          if (lastLength || !separatorCopy.test("")) output.push("");
        } else output.push(string.slice(lastLastIndex));
        return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
      };
    } else if ("0"[$SPLIT](undefined, 0)[LENGTH]) {
      $split = function (separator, limit) {
        return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
      };
    }
    return [function split(separator, limit) {
      var O = defined(this);
      var fn = separator == undefined ? undefined : separator[SPLIT];
      return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
    }, $split];
  });
  _fixReWks("search", 1, function (defined, SEARCH, $search) {
    return [function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    }, $search];
  });
  var TO_STRING = "toString";
  var $toString = /./[TO_STRING];
  var define = function (fn) {
    _redefine(RegExp.prototype, TO_STRING, fn, true);
  };
  if (_fails(function () {
    return $toString.call({
      source: "a",
      flags: "b"
    }) != "/a/b";
  })) {
    define(function toString() {
      var R = _anObject(this);
      return "/".concat(R.source, "/", "flags" in R ? R.flags : !_descriptors && R instanceof RegExp ? _flags.call(R) : undefined);
    });
  } else if ($toString.name != TO_STRING) {
    define(function toString() {
      return $toString.call(this);
    });
  }
  var SET = "Set";
  var es6_set = _collection(SET, function (get) {
    return function Set() {
      return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
  }, {
    add: function add(value) {
      return _collectionStrong.def(_validateCollection(this, SET), value = value === 0 ? 0 : value, value);
    }
  }, _collectionStrong);
  var f$7 = _wks;
  var _wksExt = {
    f: f$7
  };
  var defineProperty = _objectDp.f;
  var _wksDefine = function (name) {
    var $Symbol = _core.Symbol || (_core.Symbol = _global.Symbol || {});
    if (name.charAt(0) != "_" && !(name in $Symbol)) defineProperty($Symbol, name, {
      value: _wksExt.f(name)
    });
  };
  var _enumKeys = function (it) {
    var result = _objectKeys(it);
    var getSymbols = _objectGops.f;
    if (getSymbols) {
      var symbols = getSymbols(it);
      var isEnum = _objectPie.f;
      var i = 0;
      var key;
      while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
  };
  var META = _meta.KEY;
  var gOPD$3 = _objectGopd.f;
  var dP$5 = _objectDp.f;
  var gOPN$3 = _objectGopnExt.f;
  var $Symbol = _global.Symbol;
  var $JSON = _global.JSON;
  var _stringify = $JSON && $JSON.stringify;
  var PROTOTYPE$2 = "prototype";
  var HIDDEN = _wks("_hidden");
  var TO_PRIMITIVE$1 = _wks("toPrimitive");
  var isEnum$1 = {}.propertyIsEnumerable;
  var SymbolRegistry = _shared("symbol-registry");
  var AllSymbols = _shared("symbols");
  var OPSymbols = _shared("op-symbols");
  var ObjectProto$1 = Object[PROTOTYPE$2];
  var USE_NATIVE$1 = typeof $Symbol == "function";
  var QObject = _global.QObject;
  var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild;
  var setSymbolDesc = _descriptors && _fails(function () {
    return _objectCreate(dP$5({}, "a", {
      get: function () {
        return dP$5(this, "a", {
          value: 7
        }).a;
      }
    })).a != 7;
  }) ? function (it, key, D) {
    var protoDesc = gOPD$3(ObjectProto$1, key);
    if (protoDesc) delete ObjectProto$1[key];
    dP$5(it, key, D);
    if (protoDesc && it !== ObjectProto$1) dP$5(ObjectProto$1, key, protoDesc);
  } : dP$5;
  var wrap = function (tag) {
    var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);
    sym._k = tag;
    return sym;
  };
  var isSymbol = USE_NATIVE$1 && typeof $Symbol.iterator == "symbol" ? function (it) {
    return typeof it == "symbol";
  } : function (it) {
    return it instanceof $Symbol;
  };
  var $defineProperty = function defineProperty(it, key, D) {
    if (it === ObjectProto$1) $defineProperty(OPSymbols, key, D);
    _anObject(it);
    key = _toPrimitive(key, true);
    _anObject(D);
    if (_has(AllSymbols, key)) {
      if (!D.enumerable) {
        if (!_has(it, HIDDEN)) dP$5(it, HIDDEN, _propertyDesc(1, {}));
        it[HIDDEN][key] = true;
      } else {
        if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
        D = _objectCreate(D, {
          enumerable: _propertyDesc(0, false)
        });
      }
      return setSymbolDesc(it, key, D);
    }
    return dP$5(it, key, D);
  };
  var $defineProperties = function defineProperties(it, P) {
    _anObject(it);
    var keys = _enumKeys(P = _toIobject(P));
    var i = 0;
    var l = keys.length;
    var key;
    while (l > i) $defineProperty(it, key = keys[i++], P[key]);
    return it;
  };
  var $create = function create(it, P) {
    return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
  };
  var $propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = isEnum$1.call(this, key = _toPrimitive(key, true));
    if (this === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
    return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
  };
  var $getOwnPropertyDescriptor$1 = function getOwnPropertyDescriptor(it, key) {
    it = _toIobject(it);
    key = _toPrimitive(key, true);
    if (it === ObjectProto$1 && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
    var D = gOPD$3(it, key);
    if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
    return D;
  };
  var $getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = gOPN$3(_toIobject(it));
    var result = [];
    var i = 0;
    var key;
    while (names.length > i) {
      if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
    }
    return result;
  };
  var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === ObjectProto$1;
    var names = gOPN$3(IS_OP ? OPSymbols : _toIobject(it));
    var result = [];
    var i = 0;
    var key;
    while (names.length > i) {
      if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto$1, key) : true)) result.push(AllSymbols[key]);
    }
    return result;
  };
  if (!USE_NATIVE$1) {
    $Symbol = function Symbol() {
      if (this instanceof $Symbol) throw TypeError("Symbol is not a constructor!");
      var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);
      var $set = function (value) {
        if (this === ObjectProto$1) $set.call(OPSymbols, value);
        if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
        setSymbolDesc(this, tag, _propertyDesc(1, value));
      };
      if (_descriptors && setter) setSymbolDesc(ObjectProto$1, tag, {
        configurable: true,
        set: $set
      });
      return wrap(tag);
    };
    _redefine($Symbol[PROTOTYPE$2], "toString", function toString() {
      return this._k;
    });
    _objectGopd.f = $getOwnPropertyDescriptor$1;
    _objectDp.f = $defineProperty;
    _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
    _objectPie.f = $propertyIsEnumerable;
    _objectGops.f = $getOwnPropertySymbols;
    if (_descriptors && !_library) {
      _redefine(ObjectProto$1, "propertyIsEnumerable", $propertyIsEnumerable, true);
    }
    _wksExt.f = function (name) {
      return wrap(_wks(name));
    };
  }
  _export(_export.G + _export.W + _export.F * !USE_NATIVE$1, {
    Symbol: $Symbol
  });
  for (var es6Symbols = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), j$1 = 0; es6Symbols.length > j$1;) _wks(es6Symbols[j$1++]);
  for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);
  _export(_export.S + _export.F * !USE_NATIVE$1, "Symbol", {
    for: function (key) {
      return _has(SymbolRegistry, key += "") ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
    },
    keyFor: function keyFor(sym) {
      if (!isSymbol(sym)) throw TypeError(sym + " is not a symbol!");
      for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
    },
    useSetter: function () {
      setter = true;
    },
    useSimple: function () {
      setter = false;
    }
  });
  _export(_export.S + _export.F * !USE_NATIVE$1, "Object", {
    create: $create,
    defineProperty: $defineProperty,
    defineProperties: $defineProperties,
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor$1,
    getOwnPropertyNames: $getOwnPropertyNames,
    getOwnPropertySymbols: $getOwnPropertySymbols
  });
  $JSON && _export(_export.S + _export.F * (!USE_NATIVE$1 || _fails(function () {
    var S = $Symbol();
    return _stringify([S]) != "[null]" || _stringify({
      a: S
    }) != "{}" || _stringify(Object(S)) != "{}";
  })), "JSON", {
    stringify: function stringify(it) {
      var args = [it];
      var i = 1;
      var replacer, $replacer;
      while (arguments.length > i) args.push(arguments[i++]);
      $replacer = replacer = args[1];
      if (!_isObject(replacer) && it === undefined || isSymbol(it)) return;
      if (!_isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == "function") value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return _stringify.apply($JSON, args);
    }
  });
  $Symbol[PROTOTYPE$2][TO_PRIMITIVE$1] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE$1, $Symbol[PROTOTYPE$2].valueOf);
  _setToStringTag($Symbol, "Symbol");
  _setToStringTag(Math, "Math", true);
  _setToStringTag(_global.JSON, "JSON", true);
  _wksDefine("asyncIterator");
  var quot = /"/g;
  var createHTML = function (string, tag, attribute, value) {
    var S = String(_defined(string));
    var p1 = "<" + tag;
    if (attribute !== "") p1 += " " + attribute + '="' + String(value).replace(quot, "&quot;") + '"';
    return p1 + ">" + S + "</" + tag + ">";
  };
  var _stringHtml = function (NAME, exec) {
    var O = {};
    O[NAME] = exec(createHTML);
    _export(_export.P + _export.F * _fails(function () {
      var test = ""[NAME]('"');
      return test !== test.toLowerCase() || test.split('"').length > 3;
    }), "String", O);
  };
  _stringHtml("anchor", function (createHTML) {
    return function anchor(name) {
      return createHTML(this, "a", "name", name);
    };
  });
  _stringHtml("big", function (createHTML) {
    return function big() {
      return createHTML(this, "big", "", "");
    };
  });
  _stringHtml("blink", function (createHTML) {
    return function blink() {
      return createHTML(this, "blink", "", "");
    };
  });
  _stringHtml("bold", function (createHTML) {
    return function bold() {
      return createHTML(this, "b", "", "");
    };
  });
  var _stringAt = function (TO_STRING) {
    return function (that, pos) {
      var s = String(_defined(that));
      var i = _toInteger(pos);
      var l = s.length;
      var a, b;
      if (i < 0 || i >= l) return TO_STRING ? "" : undefined;
      a = s.charCodeAt(i);
      return a < 55296 || a > 56319 || i + 1 === l || (b = s.charCodeAt(i + 1)) < 56320 || b > 57343 ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 55296 << 10) + (b - 56320) + 65536;
    };
  };
  var $at = _stringAt(false);
  _export(_export.P, "String", {
    codePointAt: function codePointAt(pos) {
      return $at(this, pos);
    }
  });
  var _stringContext = function (that, searchString, NAME) {
    if (_isRegexp(searchString)) throw TypeError("String#" + NAME + " doesn't accept regex!");
    return String(_defined(that));
  };
  var MATCH$1 = _wks("match");
  var _failsIsRegexp = function (KEY) {
    var re = /./;
    try {
      "/./"[KEY](re);
    } catch (e) {
      try {
        re[MATCH$1] = false;
        return !"/./"[KEY](re);
      } catch (f) { }
    }
    return true;
  };
  var ENDS_WITH = "endsWith";
  var $endsWith = ""[ENDS_WITH];
  _export(_export.P + _export.F * _failsIsRegexp(ENDS_WITH), "String", {
    endsWith: function endsWith(searchString) {
      var that = _stringContext(this, searchString, ENDS_WITH);
      var endPosition = arguments.length > 1 ? arguments[1] : undefined;
      var len = _toLength(that.length);
      var end = endPosition === undefined ? len : Math.min(_toLength(endPosition), len);
      var search = String(searchString);
      return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
    }
  });
  _stringHtml("fixed", function (createHTML) {
    return function fixed() {
      return createHTML(this, "tt", "", "");
    };
  });
  _stringHtml("fontcolor", function (createHTML) {
    return function fontcolor(color) {
      return createHTML(this, "font", "color", color);
    };
  });
  _stringHtml("fontsize", function (createHTML) {
    return function fontsize(size) {
      return createHTML(this, "font", "size", size);
    };
  });
  var fromCharCode = String.fromCharCode;
  var $fromCodePoint = String.fromCodePoint;
  _export(_export.S + _export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), "String", {
    fromCodePoint: function fromCodePoint(x) {
      var res = [];
      var aLen = arguments.length;
      var i = 0;
      var code;
      while (aLen > i) {
        code = +arguments[i++];
        if (_toAbsoluteIndex(code, 1114111) !== code) throw RangeError(code + " is not a valid code point");
        res.push(code < 65536 ? fromCharCode(code) : fromCharCode(((code -= 65536) >> 10) + 55296, code % 1024 + 56320));
      }
      return res.join("");
    }
  });
  var INCLUDES = "includes";
  _export(_export.P + _export.F * _failsIsRegexp(INCLUDES), "String", {
    includes: function includes(searchString) {
      return !!~_stringContext(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
    }
  });
  _stringHtml("italics", function (createHTML) {
    return function italics() {
      return createHTML(this, "i", "", "");
    };
  });
  var $at$1 = _stringAt(true);
  _iterDefine(String, "String", function (iterated) {
    this._t = String(iterated);
    this._i = 0;
  }, function () {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
      value: undefined,
      done: true
    };
    point = $at$1(O, index);
    this._i += point.length;
    return {
      value: point,
      done: false
    };
  });
  _stringHtml("link", function (createHTML) {
    return function link(url) {
      return createHTML(this, "a", "href", url);
    };
  });
  var _stringRepeat = function repeat(count) {
    var str = String(_defined(this));
    var res = "";
    var n = _toInteger(count);
    if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
    for (; n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
    return res;
  };
  var _stringPad = function (that, maxLength, fillString, left) {
    var S = String(_defined(that));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? " " : String(fillString);
    var intMaxLength = _toLength(maxLength);
    if (intMaxLength <= stringLength || fillStr == "") return S;
    var fillLen = intMaxLength - stringLength;
    var stringFiller = _stringRepeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return left ? stringFiller + S : S + stringFiller;
  };
  _export(_export.P + _export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(_userAgent), "String", {
    padStart: function padStart(maxLength) {
      return _stringPad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
    }
  });
  _export(_export.P + _export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(_userAgent), "String", {
    padEnd: function padEnd(maxLength) {
      return _stringPad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
    }
  });
  _export(_export.S, "String", {
    raw: function raw(callSite) {
      var tpl = _toIobject(callSite.raw);
      var len = _toLength(tpl.length);
      var aLen = arguments.length;
      var res = [];
      var i = 0;
      while (len > i) {
        res.push(String(tpl[i++]));
        if (i < aLen) res.push(String(arguments[i]));
      }
      return res.join("");
    }
  });
  _export(_export.P, "String", {
    repeat: _stringRepeat
  });
  _stringHtml("small", function (createHTML) {
    return function small() {
      return createHTML(this, "small", "", "");
    };
  });
  var STARTS_WITH = "startsWith";
  var $startsWith = ""[STARTS_WITH];
  _export(_export.P + _export.F * _failsIsRegexp(STARTS_WITH), "String", {
    startsWith: function startsWith(searchString) {
      var that = _stringContext(this, searchString, STARTS_WITH);
      var index = _toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
      var search = String(searchString);
      return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
    }
  });
  _stringHtml("strike", function (createHTML) {
    return function strike() {
      return createHTML(this, "strike", "", "");
    };
  });
  _stringHtml("sub", function (createHTML) {
    return function sub() {
      return createHTML(this, "sub", "", "");
    };
  });
  _stringHtml("sup", function (createHTML) {
    return function sup() {
      return createHTML(this, "sup", "", "");
    };
  });
  var TYPED = _uid("typed_array");
  var VIEW = _uid("view");
  var ABV = !!(_global.ArrayBuffer && _global.DataView);
  var CONSTR = ABV;
  var i$1 = 0;
  var l = 9;
  var Typed;
  var TypedArrayConstructors = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(",");
  while (i$1 < l) {
    if (Typed = _global[TypedArrayConstructors[i$1++]]) {
      _hide(Typed.prototype, TYPED, true);
      _hide(Typed.prototype, VIEW, true);
    } else CONSTR = false;
  }
  var _typed = {
    ABV: ABV,
    CONSTR: CONSTR,
    TYPED: TYPED,
    VIEW: VIEW
  };
  var _toIndex = function (it) {
    if (it === undefined) return 0;
    var number = _toInteger(it);
    var length = _toLength(number);
    if (number !== length) throw RangeError("Wrong length!");
    return length;
  };
  var _typedBuffer = createCommonjsModule(function (module, exports) {
    var gOPN = _objectGopn.f;
    var dP = _objectDp.f;
    var ARRAY_BUFFER = "ArrayBuffer";
    var DATA_VIEW = "DataView";
    var PROTOTYPE = "prototype";
    var WRONG_LENGTH = "Wrong length!";
    var WRONG_INDEX = "Wrong index!";
    var $ArrayBuffer = _global[ARRAY_BUFFER];
    var $DataView = _global[DATA_VIEW];
    var Math = _global.Math;
    var RangeError = _global.RangeError;
    var Infinity = _global.Infinity;
    var BaseBuffer = $ArrayBuffer;
    var abs = Math.abs;
    var pow = Math.pow;
    var floor = Math.floor;
    var log = Math.log;
    var LN2 = Math.LN2;
    var BUFFER = "buffer";
    var BYTE_LENGTH = "byteLength";
    var BYTE_OFFSET = "byteOffset";
    var $BUFFER = _descriptors ? "_b" : BUFFER;
    var $LENGTH = _descriptors ? "_l" : BYTE_LENGTH;
    var $OFFSET = _descriptors ? "_o" : BYTE_OFFSET;
    function packIEEE754(value, mLen, nBytes) {
      var buffer = new Array(nBytes);
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
      var i = 0;
      var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
      var e, m, c;
      value = abs(value);
      if (value != value || value === Infinity) {
        m = value != value ? 1 : 0;
        e = eMax;
      } else {
        e = floor(log(value) / LN2);
        if (value * (c = pow(2, -e)) < 1) {
          e--;
          c *= 2;
        }
        if (e + eBias >= 1) {
          value += rt / c;
        } else {
          value += rt * pow(2, 1 - eBias);
        }
        if (value * c >= 2) {
          e++;
          c /= 2;
        }
        if (e + eBias >= eMax) {
          m = 0;
          e = eMax;
        } else if (e + eBias >= 1) {
          m = (value * c - 1) * pow(2, mLen);
          e = e + eBias;
        } else {
          m = value * pow(2, eBias - 1) * pow(2, mLen);
          e = 0;
        }
      }
      for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
      e = e << mLen | m;
      eLen += mLen;
      for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
      buffer[--i] |= s * 128;
      return buffer;
    }
    function unpackIEEE754(buffer, mLen, nBytes) {
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var nBits = eLen - 7;
      var i = nBytes - 1;
      var s = buffer[i--];
      var e = s & 127;
      var m;
      s >>= 7;
      for (; nBits > 0; e = e * 256 + buffer[i], i-- , nBits -= 8);
      m = e & (1 << -nBits) - 1;
      e >>= -nBits;
      nBits += mLen;
      for (; nBits > 0; m = m * 256 + buffer[i], i-- , nBits -= 8);
      if (e === 0) {
        e = 1 - eBias;
      } else if (e === eMax) {
        return m ? NaN : s ? -Infinity : Infinity;
      } else {
        m = m + pow(2, mLen);
        e = e - eBias;
      }
      return (s ? -1 : 1) * m * pow(2, e - mLen);
    }
    function unpackI32(bytes) {
      return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
    }
    function packI8(it) {
      return [it & 255];
    }
    function packI16(it) {
      return [it & 255, it >> 8 & 255];
    }
    function packI32(it) {
      return [it & 255, it >> 8 & 255, it >> 16 & 255, it >> 24 & 255];
    }
    function packF64(it) {
      return packIEEE754(it, 52, 8);
    }
    function packF32(it) {
      return packIEEE754(it, 23, 4);
    }
    function addGetter(C, key, internal) {
      dP(C[PROTOTYPE], key, {
        get: function () {
          return this[internal];
        }
      });
    }
    function get(view, bytes, index, isLittleEndian) {
      var numIndex = +index;
      var intIndex = _toIndex(numIndex);
      if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
      var store = view[$BUFFER]._b;
      var start = intIndex + view[$OFFSET];
      var pack = store.slice(start, start + bytes);
      return isLittleEndian ? pack : pack.reverse();
    }
    function set(view, bytes, index, conversion, value, isLittleEndian) {
      var numIndex = +index;
      var intIndex = _toIndex(numIndex);
      if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
      var store = view[$BUFFER]._b;
      var start = intIndex + view[$OFFSET];
      var pack = conversion(+value);
      for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
    }
    if (!_typed.ABV) {
      $ArrayBuffer = function ArrayBuffer(length) {
        _anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
        var byteLength = _toIndex(length);
        this._b = _arrayFill.call(new Array(byteLength), 0);
        this[$LENGTH] = byteLength;
      };
      $DataView = function DataView(buffer, byteOffset, byteLength) {
        _anInstance(this, $DataView, DATA_VIEW);
        _anInstance(buffer, $ArrayBuffer, DATA_VIEW);
        var bufferLength = buffer[$LENGTH];
        var offset = _toInteger(byteOffset);
        if (offset < 0 || offset > bufferLength) throw RangeError("Wrong offset!");
        byteLength = byteLength === undefined ? bufferLength - offset : _toLength(byteLength);
        if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
        this[$BUFFER] = buffer;
        this[$OFFSET] = offset;
        this[$LENGTH] = byteLength;
      };
      if (_descriptors) {
        addGetter($ArrayBuffer, BYTE_LENGTH, "_l");
        addGetter($DataView, BUFFER, "_b");
        addGetter($DataView, BYTE_LENGTH, "_l");
        addGetter($DataView, BYTE_OFFSET, "_o");
      }
      _redefineAll($DataView[PROTOTYPE], {
        getInt8: function getInt8(byteOffset) {
          return get(this, 1, byteOffset)[0] << 24 >> 24;
        },
        getUint8: function getUint8(byteOffset) {
          return get(this, 1, byteOffset)[0];
        },
        getInt16: function getInt16(byteOffset) {
          var bytes = get(this, 2, byteOffset, arguments[1]);
          return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
        },
        getUint16: function getUint16(byteOffset) {
          var bytes = get(this, 2, byteOffset, arguments[1]);
          return bytes[1] << 8 | bytes[0];
        },
        getInt32: function getInt32(byteOffset) {
          return unpackI32(get(this, 4, byteOffset, arguments[1]));
        },
        getUint32: function getUint32(byteOffset) {
          return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
        },
        getFloat32: function getFloat32(byteOffset) {
          return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
        },
        getFloat64: function getFloat64(byteOffset) {
          return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
        },
        setInt8: function setInt8(byteOffset, value) {
          set(this, 1, byteOffset, packI8, value);
        },
        setUint8: function setUint8(byteOffset, value) {
          set(this, 1, byteOffset, packI8, value);
        },
        setInt16: function setInt16(byteOffset, value) {
          set(this, 2, byteOffset, packI16, value, arguments[2]);
        },
        setUint16: function setUint16(byteOffset, value) {
          set(this, 2, byteOffset, packI16, value, arguments[2]);
        },
        setInt32: function setInt32(byteOffset, value) {
          set(this, 4, byteOffset, packI32, value, arguments[2]);
        },
        setUint32: function setUint32(byteOffset, value) {
          set(this, 4, byteOffset, packI32, value, arguments[2]);
        },
        setFloat32: function setFloat32(byteOffset, value) {
          set(this, 4, byteOffset, packF32, value, arguments[2]);
        },
        setFloat64: function setFloat64(byteOffset, value) {
          set(this, 8, byteOffset, packF64, value, arguments[2]);
        }
      });
    } else {
      if (!_fails(function () {
        $ArrayBuffer(1);
      }) || !_fails(function () {
        new $ArrayBuffer(-1);
      }) || _fails(function () {
        new $ArrayBuffer();
        new $ArrayBuffer(1.5);
        new $ArrayBuffer(NaN);
        return $ArrayBuffer.name != ARRAY_BUFFER;
      })) {
        $ArrayBuffer = function ArrayBuffer(length) {
          _anInstance(this, $ArrayBuffer);
          return new BaseBuffer(_toIndex(length));
        };
        var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
        for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
          if (!((key = keys[j++]) in $ArrayBuffer)) _hide($ArrayBuffer, key, BaseBuffer[key]);
        }
        ArrayBufferProto.constructor = $ArrayBuffer;
      }
      var view = new $DataView(new $ArrayBuffer(2));
      var $setInt8 = $DataView[PROTOTYPE].setInt8;
      view.setInt8(0, 2147483648);
      view.setInt8(1, 2147483649);
      if (view.getInt8(0) || !view.getInt8(1)) _redefineAll($DataView[PROTOTYPE], {
        setInt8: function setInt8(byteOffset, value) {
          $setInt8.call(this, byteOffset, value << 24 >> 24);
        },
        setUint8: function setUint8(byteOffset, value) {
          $setInt8.call(this, byteOffset, value << 24 >> 24);
        }
      }, true);
    }
    _setToStringTag($ArrayBuffer, ARRAY_BUFFER);
    _setToStringTag($DataView, DATA_VIEW);
    _hide($DataView[PROTOTYPE], _typed.VIEW, true);
    exports[ARRAY_BUFFER] = $ArrayBuffer;
    exports[DATA_VIEW] = $DataView;
  });
  var ArrayBuffer = _global.ArrayBuffer;
  var $ArrayBuffer = _typedBuffer.ArrayBuffer;
  var $DataView = _typedBuffer.DataView;
  var $isView = _typed.ABV && ArrayBuffer.isView;
  var $slice = $ArrayBuffer.prototype.slice;
  var VIEW$1 = _typed.VIEW;
  var ARRAY_BUFFER = "ArrayBuffer";
  _export(_export.G + _export.W + _export.F * (ArrayBuffer !== $ArrayBuffer), {
    ArrayBuffer: $ArrayBuffer
  });
  _export(_export.S + _export.F * !_typed.CONSTR, ARRAY_BUFFER, {
    isView: function isView(it) {
      return $isView && $isView(it) || _isObject(it) && VIEW$1 in it;
    }
  });
  _export(_export.P + _export.U + _export.F * _fails(function () {
    return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
  }), ARRAY_BUFFER, {
    slice: function slice(start, end) {
      if ($slice !== undefined && end === undefined) return $slice.call(_anObject(this), start);
      var len = _anObject(this).byteLength;
      var first = _toAbsoluteIndex(start, len);
      var fin = _toAbsoluteIndex(end === undefined ? len : end, len);
      var result = new (_speciesConstructor(this, $ArrayBuffer))(_toLength(fin - first));
      var viewS = new $DataView(this);
      var viewT = new $DataView(result);
      var index = 0;
      while (first < fin) {
        viewT.setUint8(index++, viewS.getUint8(first++));
      }
      return result;
    }
  });
  _setSpecies(ARRAY_BUFFER);
  var _typedArray = createCommonjsModule(function (module) {
    if (_descriptors) {
      var global = _global;
      var fails = _fails;
      var $export = _export;
      var $typed = _typed;
      var $buffer = _typedBuffer;
      var ctx = _ctx;
      var anInstance = _anInstance;
      var propertyDesc = _propertyDesc;
      var hide = _hide;
      var redefineAll = _redefineAll;
      var toInteger = _toInteger;
      var toLength = _toLength;
      var toIndex = _toIndex;
      var toAbsoluteIndex = _toAbsoluteIndex;
      var toPrimitive = _toPrimitive;
      var has = _has;
      var classof = _classof;
      var isObject = _isObject;
      var toObject = _toObject;
      var isArrayIter = _isArrayIter;
      var create = _objectCreate;
      var getPrototypeOf = _objectGpo;
      var gOPN = _objectGopn.f;
      var getIterFn = core_getIteratorMethod;
      var uid = _uid;
      var wks = _wks;
      var createArrayMethod = _arrayMethods;
      var createArrayIncludes = _arrayIncludes;
      var speciesConstructor = _speciesConstructor;
      var ArrayIterators = es6_array_iterator;
      var Iterators = _iterators;
      var $iterDetect = _iterDetect;
      var setSpecies = _setSpecies;
      var arrayFill = _arrayFill;
      var arrayCopyWithin = _arrayCopyWithin;
      var $DP = _objectDp;
      var $GOPD = _objectGopd;
      var dP = $DP.f;
      var gOPD = $GOPD.f;
      var RangeError = global.RangeError;
      var TypeError = global.TypeError;
      var Uint8Array = global.Uint8Array;
      var ARRAY_BUFFER = "ArrayBuffer";
      var SHARED_BUFFER = "Shared" + ARRAY_BUFFER;
      var BYTES_PER_ELEMENT = "BYTES_PER_ELEMENT";
      var PROTOTYPE = "prototype";
      var ArrayProto = Array[PROTOTYPE];
      var $ArrayBuffer = $buffer.ArrayBuffer;
      var $DataView = $buffer.DataView;
      var arrayForEach = createArrayMethod(0);
      var arrayFilter = createArrayMethod(2);
      var arraySome = createArrayMethod(3);
      var arrayEvery = createArrayMethod(4);
      var arrayFind = createArrayMethod(5);
      var arrayFindIndex = createArrayMethod(6);
      var arrayIncludes = createArrayIncludes(true);
      var arrayIndexOf = createArrayIncludes(false);
      var arrayValues = ArrayIterators.values;
      var arrayKeys = ArrayIterators.keys;
      var arrayEntries = ArrayIterators.entries;
      var arrayLastIndexOf = ArrayProto.lastIndexOf;
      var arrayReduce = ArrayProto.reduce;
      var arrayReduceRight = ArrayProto.reduceRight;
      var arrayJoin = ArrayProto.join;
      var arraySort = ArrayProto.sort;
      var arraySlice = ArrayProto.slice;
      var arrayToString = ArrayProto.toString;
      var arrayToLocaleString = ArrayProto.toLocaleString;
      var ITERATOR = wks("iterator");
      var TAG = wks("toStringTag");
      var TYPED_CONSTRUCTOR = uid("typed_constructor");
      var DEF_CONSTRUCTOR = uid("def_constructor");
      var ALL_CONSTRUCTORS = $typed.CONSTR;
      var TYPED_ARRAY = $typed.TYPED;
      var VIEW = $typed.VIEW;
      var WRONG_LENGTH = "Wrong length!";
      var $map = createArrayMethod(1, function (O, length) {
        return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
      });
      var LITTLE_ENDIAN = fails(function () {
        return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
      });
      var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
        new Uint8Array(1).set({});
      });
      var toOffset = function (it, BYTES) {
        var offset = toInteger(it);
        if (offset < 0 || offset % BYTES) throw RangeError("Wrong offset!");
        return offset;
      };
      var validate = function (it) {
        if (isObject(it) && TYPED_ARRAY in it) return it;
        throw TypeError(it + " is not a typed array!");
      };
      var allocate = function (C, length) {
        if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
          throw TypeError("It is not a typed array constructor!");
        }
        return new C(length);
      };
      var speciesFromList = function (O, list) {
        return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
      };
      var fromList = function (C, list) {
        var index = 0;
        var length = list.length;
        var result = allocate(C, length);
        while (length > index) result[index] = list[index++];
        return result;
      };
      var addGetter = function (it, key, internal) {
        dP(it, key, {
          get: function () {
            return this._d[internal];
          }
        });
      };
      var $from = function from(source) {
        var O = toObject(source);
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var iterFn = getIterFn(O);
        var i, length, values, result, step, iterator;
        if (iterFn != undefined && !isArrayIter(iterFn)) {
          for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
            values.push(step.value);
          }
          O = values;
        }
        if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
        for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
          result[i] = mapping ? mapfn(O[i], i) : O[i];
        }
        return result;
      };
      var $of = function of() {
        var index = 0;
        var length = arguments.length;
        var result = allocate(this, length);
        while (length > index) result[index] = arguments[index++];
        return result;
      };
      var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
        arrayToLocaleString.call(new Uint8Array(1));
      });
      var $toLocaleString = function toLocaleString() {
        return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
      };
      var proto = {
        copyWithin: function copyWithin(target, start) {
          return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
        },
        every: function every(callbackfn) {
          return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        fill: function fill(value) {
          return arrayFill.apply(validate(this), arguments);
        },
        filter: function filter(callbackfn) {
          return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
        },
        find: function find(predicate) {
          return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
        },
        findIndex: function findIndex(predicate) {
          return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
        },
        forEach: function forEach(callbackfn) {
          arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        indexOf: function indexOf(searchElement) {
          return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
        },
        includes: function includes(searchElement) {
          return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
        },
        join: function join(separator) {
          return arrayJoin.apply(validate(this), arguments);
        },
        lastIndexOf: function lastIndexOf(searchElement) {
          return arrayLastIndexOf.apply(validate(this), arguments);
        },
        map: function map(mapfn) {
          return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        reduce: function reduce(callbackfn) {
          return arrayReduce.apply(validate(this), arguments);
        },
        reduceRight: function reduceRight(callbackfn) {
          return arrayReduceRight.apply(validate(this), arguments);
        },
        reverse: function reverse() {
          var that = this;
          var length = validate(that).length;
          var middle = Math.floor(length / 2);
          var index = 0;
          var value;
          while (index < middle) {
            value = that[index];
            that[index++] = that[--length];
            that[length] = value;
          }
          return that;
        },
        some: function some(callbackfn) {
          return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        sort: function sort(comparefn) {
          return arraySort.call(validate(this), comparefn);
        },
        subarray: function subarray(begin, end) {
          var O = validate(this);
          var length = O.length;
          var $begin = toAbsoluteIndex(begin, length);
          return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin));
        }
      };
      var $slice = function slice(start, end) {
        return speciesFromList(this, arraySlice.call(validate(this), start, end));
      };
      var $set = function set(arrayLike) {
        validate(this);
        var offset = toOffset(arguments[1], 1);
        var length = this.length;
        var src = toObject(arrayLike);
        var len = toLength(src.length);
        var index = 0;
        if (len + offset > length) throw RangeError(WRONG_LENGTH);
        while (index < len) this[offset + index] = src[index++];
      };
      var $iterators = {
        entries: function entries() {
          return arrayEntries.call(validate(this));
        },
        keys: function keys() {
          return arrayKeys.call(validate(this));
        },
        values: function values() {
          return arrayValues.call(validate(this));
        }
      };
      var isTAIndex = function (target, key) {
        return isObject(target) && target[TYPED_ARRAY] && typeof key != "symbol" && key in target && String(+key) == String(key);
      };
      var $getDesc = function getOwnPropertyDescriptor(target, key) {
        return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
      };
      var $setDesc = function defineProperty(target, key, desc) {
        if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, "value") && !has(desc, "get") && !has(desc, "set") && !desc.configurable && (!has(desc, "writable") || desc.writable) && (!has(desc, "enumerable") || desc.enumerable)) {
          target[key] = desc.value;
          return target;
        }
        return dP(target, key, desc);
      };
      if (!ALL_CONSTRUCTORS) {
        $GOPD.f = $getDesc;
        $DP.f = $setDesc;
      }
      $export($export.S + $export.F * !ALL_CONSTRUCTORS, "Object", {
        getOwnPropertyDescriptor: $getDesc,
        defineProperty: $setDesc
      });
      if (fails(function () {
        arrayToString.call({});
      })) {
        arrayToString = arrayToLocaleString = function toString() {
          return arrayJoin.call(this);
        };
      }
      var $TypedArrayPrototype$ = redefineAll({}, proto);
      redefineAll($TypedArrayPrototype$, $iterators);
      hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
      redefineAll($TypedArrayPrototype$, {
        slice: $slice,
        set: $set,
        constructor: function () { },
        toString: arrayToString,
        toLocaleString: $toLocaleString
      });
      addGetter($TypedArrayPrototype$, "buffer", "b");
      addGetter($TypedArrayPrototype$, "byteOffset", "o");
      addGetter($TypedArrayPrototype$, "byteLength", "l");
      addGetter($TypedArrayPrototype$, "length", "e");
      dP($TypedArrayPrototype$, TAG, {
        get: function () {
          return this[TYPED_ARRAY];
        }
      });
      module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
        CLAMPED = !!CLAMPED;
        var NAME = KEY + (CLAMPED ? "Clamped" : "") + "Array";
        var GETTER = "get" + KEY;
        var SETTER = "set" + KEY;
        var TypedArray = global[NAME];
        var Base = TypedArray || {};
        var TAC = TypedArray && getPrototypeOf(TypedArray);
        var FORCED = !TypedArray || !$typed.ABV;
        var O = {};
        var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
        var getter = function (that, index) {
          var data = that._d;
          return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
        };
        var setter = function (that, index, value) {
          var data = that._d;
          if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 255 ? 255 : value & 255;
          data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
        };
        var addElement = function (that, index) {
          dP(that, index, {
            get: function () {
              return getter(this, index);
            },
            set: function (value) {
              return setter(this, index, value);
            },
            enumerable: true
          });
        };
        if (FORCED) {
          TypedArray = wrapper(function (that, data, $offset, $length) {
            anInstance(that, TypedArray, NAME, "_d");
            var index = 0;
            var offset = 0;
            var buffer, byteLength, length, klass;
            if (!isObject(data)) {
              length = toIndex(data);
              byteLength = length * BYTES;
              buffer = new $ArrayBuffer(byteLength);
            } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
              buffer = data;
              offset = toOffset($offset, BYTES);
              var $len = data.byteLength;
              if ($length === undefined) {
                if ($len % BYTES) throw RangeError(WRONG_LENGTH);
                byteLength = $len - offset;
                if (byteLength < 0) throw RangeError(WRONG_LENGTH);
              } else {
                byteLength = toLength($length) * BYTES;
                if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
              }
              length = byteLength / BYTES;
            } else if (TYPED_ARRAY in data) {
              return fromList(TypedArray, data);
            } else {
              return $from.call(TypedArray, data);
            }
            hide(that, "_d", {
              b: buffer,
              o: offset,
              l: byteLength,
              e: length,
              v: new $DataView(buffer)
            });
            while (index < length) addElement(that, index++);
          });
          TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
          hide(TypedArrayPrototype, "constructor", TypedArray);
        } else if (!fails(function () {
          TypedArray(1);
        }) || !fails(function () {
          new TypedArray(-1);
        }) || !$iterDetect(function (iter) {
          new TypedArray();
          new TypedArray(null);
          new TypedArray(1.5);
          new TypedArray(iter);
        }, true)) {
          TypedArray = wrapper(function (that, data, $offset, $length) {
            anInstance(that, TypedArray, NAME);
            var klass;
            if (!isObject(data)) return new Base(toIndex(data));
            if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
              return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
            }
            if (TYPED_ARRAY in data) return fromList(TypedArray, data);
            return $from.call(TypedArray, data);
          });
          arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
            if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
          });
          TypedArray[PROTOTYPE] = TypedArrayPrototype;
          TypedArrayPrototype.constructor = TypedArray;
        }
        var $nativeIterator = TypedArrayPrototype[ITERATOR];
        var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == "values" || $nativeIterator.name == undefined);
        var $iterator = $iterators.values;
        hide(TypedArray, TYPED_CONSTRUCTOR, true);
        hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
        hide(TypedArrayPrototype, VIEW, true);
        hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
        if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
          dP(TypedArrayPrototype, TAG, {
            get: function () {
              return NAME;
            }
          });
        }
        O[NAME] = TypedArray;
        $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
        $export($export.S, NAME, {
          BYTES_PER_ELEMENT: BYTES
        });
        $export($export.S + $export.F * fails(function () {
          Base.of.call(TypedArray, 1);
        }), NAME, {
          from: $from,
          of: $of
        });
        if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
        $export($export.P, NAME, proto);
        setSpecies(NAME);
        $export($export.P + $export.F * FORCED_SET, NAME, {
          set: $set
        });
        $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
        if (TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
        $export($export.P + $export.F * fails(function () {
          new TypedArray(1).slice();
        }), NAME, {
          slice: $slice
        });
        $export($export.P + $export.F * (fails(function () {
          return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
        }) || !fails(function () {
          TypedArrayPrototype.toLocaleString.call([1, 2]);
        })), NAME, {
          toLocaleString: $toLocaleString
        });
        Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
        if (!CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
      };
    } else module.exports = function () { };
  });
  _typedArray("Int8", 1, function (init) {
    return function Int8Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  _typedArray("Uint8", 1, function (init) {
    return function Uint8Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  _typedArray("Uint8", 1, function (init) {
    return function Uint8ClampedArray(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  }, true);
  _typedArray("Int16", 2, function (init) {
    return function Int16Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  _typedArray("Uint16", 2, function (init) {
    return function Uint16Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  _typedArray("Int32", 4, function (init) {
    return function Int32Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  _typedArray("Uint32", 4, function (init) {
    return function Uint32Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  _typedArray("Float32", 4, function (init) {
    return function Float32Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  _typedArray("Float64", 8, function (init) {
    return function Float64Array(data, byteOffset, length) {
      return init(this, data, byteOffset, length);
    };
  });
  var getWeak = _meta.getWeak;
  var arrayFind = _arrayMethods(5);
  var arrayFindIndex = _arrayMethods(6);
  var id$1 = 0;
  var uncaughtFrozenStore = function (that) {
    return that._l || (that._l = new UncaughtFrozenStore());
  };
  var UncaughtFrozenStore = function () {
    this.a = [];
  };
  var findUncaughtFrozen = function (store, key) {
    return arrayFind(store.a, function (it) {
      return it[0] === key;
    });
  };
  UncaughtFrozenStore.prototype = {
    get: function (key) {
      var entry = findUncaughtFrozen(this, key);
      if (entry) return entry[1];
    },
    has: function (key) {
      return !!findUncaughtFrozen(this, key);
    },
    set: function (key, value) {
      var entry = findUncaughtFrozen(this, key);
      if (entry) entry[1] = value; else this.a.push([key, value]);
    },
    delete: function (key) {
      var index = arrayFindIndex(this.a, function (it) {
        return it[0] === key;
      });
      if (~index) this.a.splice(index, 1);
      return !!~index;
    }
  };
  var _collectionWeak = {
    getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
      var C = wrapper(function (that, iterable) {
        _anInstance(that, C, NAME, "_i");
        that._t = NAME;
        that._i = id$1++;
        that._l = undefined;
        if (iterable != undefined) _forOf(iterable, IS_MAP, that[ADDER], that);
      });
      _redefineAll(C.prototype, {
        delete: function (key) {
          if (!_isObject(key)) return false;
          var data = getWeak(key);
          if (data === true) return uncaughtFrozenStore(_validateCollection(this, NAME))["delete"](key);
          return data && _has(data, this._i) && delete data[this._i];
        },
        has: function has(key) {
          if (!_isObject(key)) return false;
          var data = getWeak(key);
          if (data === true) return uncaughtFrozenStore(_validateCollection(this, NAME)).has(key);
          return data && _has(data, this._i);
        }
      });
      return C;
    },
    def: function (that, key, value) {
      var data = getWeak(_anObject(key), true);
      if (data === true) uncaughtFrozenStore(that).set(key, value); else data[that._i] = value;
      return that;
    },
    ufstore: uncaughtFrozenStore
  };
  var es6_weakMap = createCommonjsModule(function (module) {
    var each = _arrayMethods(0);
    var WEAK_MAP = "WeakMap";
    var getWeak = _meta.getWeak;
    var isExtensible = Object.isExtensible;
    var uncaughtFrozenStore = _collectionWeak.ufstore;
    var tmp = {};
    var InternalMap;
    var wrapper = function (get) {
      return function WeakMap() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
      };
    };
    var methods = {
      get: function get(key) {
        if (_isObject(key)) {
          var data = getWeak(key);
          if (data === true) return uncaughtFrozenStore(_validateCollection(this, WEAK_MAP)).get(key);
          return data ? data[this._i] : undefined;
        }
      },
      set: function set(key, value) {
        return _collectionWeak.def(_validateCollection(this, WEAK_MAP), key, value);
      }
    };
    var $WeakMap = module.exports = _collection(WEAK_MAP, wrapper, methods, _collectionWeak, true, true);
    if (_fails(function () {
      return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7;
    })) {
      InternalMap = _collectionWeak.getConstructor(wrapper, WEAK_MAP);
      _objectAssign(InternalMap.prototype, methods);
      _meta.NEED = true;
      each(["delete", "has", "get", "set"], function (key) {
        var proto = $WeakMap.prototype;
        var method = proto[key];
        _redefine(proto, key, function (a, b) {
          if (_isObject(a) && !isExtensible(a)) {
            if (!this._f) this._f = new InternalMap();
            var result = this._f[key](a, b);
            return key == "set" ? this : result;
          }
          return method.call(this, a, b);
        });
      });
    }
  });
  var WEAK_SET = "WeakSet";
  _collection(WEAK_SET, function (get) {
    return function WeakSet() {
      return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
  }, {
    add: function add(value) {
      return _collectionWeak.def(_validateCollection(this, WEAK_SET), value, true);
    }
  }, _collectionWeak, false, true);
  var slice = [].slice;
  var MSIE = /MSIE .\./.test(_userAgent);
  var wrap$1 = function (set) {
    return function (fn, time) {
      var boundArgs = arguments.length > 2;
      var args = boundArgs ? slice.call(arguments, 2) : false;
      return set(boundArgs ? function () {
        (typeof fn == "function" ? fn : Function(fn)).apply(this, args);
      } : fn, time);
    };
  };
  _export(_export.G + _export.B + _export.F * MSIE, {
    setTimeout: wrap$1(_global.setTimeout),
    setInterval: wrap$1(_global.setInterval)
  });
  _export(_export.G + _export.B, {
    setImmediate: _task.set,
    clearImmediate: _task.clear
  });
  var ITERATOR$4 = _wks("iterator");
  var TO_STRING_TAG = _wks("toStringTag");
  var ArrayValues = _iterators.Array;
  var DOMIterables = {
    CSSRuleList: true,
    CSSStyleDeclaration: false,
    CSSValueList: false,
    ClientRectList: false,
    DOMRectList: false,
    DOMStringList: false,
    DOMTokenList: true,
    DataTransferItemList: false,
    FileList: false,
    HTMLAllCollection: false,
    HTMLCollection: false,
    HTMLFormElement: false,
    HTMLSelectElement: false,
    MediaList: true,
    MimeTypeArray: false,
    NamedNodeMap: false,
    NodeList: true,
    PaintRequestList: false,
    Plugin: false,
    PluginArray: false,
    SVGLengthList: false,
    SVGNumberList: false,
    SVGPathSegList: false,
    SVGPointList: false,
    SVGStringList: false,
    SVGTransformList: false,
    SourceBufferList: false,
    StyleSheetList: true,
    TextTrackCueList: false,
    TextTrackList: false,
    TouchList: false
  };
  for (var collections = _objectKeys(DOMIterables), i$2 = 0; i$2 < collections.length; i$2++) {
    var NAME$1 = collections[i$2];
    var explicit = DOMIterables[NAME$1];
    var Collection = _global[NAME$1];
    var proto$3 = Collection && Collection.prototype;
    var key$1;
    if (proto$3) {
      if (!proto$3[ITERATOR$4]) _hide(proto$3, ITERATOR$4, ArrayValues);
      if (!proto$3[TO_STRING_TAG]) _hide(proto$3, TO_STRING_TAG, NAME$1);
      _iterators[NAME$1] = ArrayValues;
      if (explicit) for (key$1 in es6_array_iterator) if (!proto$3[key$1]) _redefine(proto$3, key$1, es6_array_iterator[key$1], true);
    }
  }
  var runtime = createCommonjsModule(function (module) {
    !function (global) {
      var Op = Object.prototype;
      var hasOwn = Op.hasOwnProperty;
      var undefined;
      var $Symbol = typeof Symbol === "function" ? Symbol : {};
      var iteratorSymbol = $Symbol.iterator || "@@iterator";
      var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
      var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
      var runtime = global.regeneratorRuntime;
      if (runtime) {
        {
          module.exports = runtime;
        }
        return;
      }
      runtime = global.regeneratorRuntime = module.exports;
      function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        generator._invoke = makeInvokeMethod(innerFn, self, context);
        return generator;
      }
      runtime.wrap = wrap;
      function tryCatch(fn, obj, arg) {
        try {
          return {
            type: "normal",
            arg: fn.call(obj, arg)
          };
        } catch (err) {
          return {
            type: "throw",
            arg: err
          };
        }
      }
      var GenStateSuspendedStart = "suspendedStart";
      var GenStateSuspendedYield = "suspendedYield";
      var GenStateExecuting = "executing";
      var GenStateCompleted = "completed";
      var ContinueSentinel = {};
      function Generator() { }
      function GeneratorFunction() { }
      function GeneratorFunctionPrototype() { }
      var IteratorPrototype = {};
      IteratorPrototype[iteratorSymbol] = function () {
        return this;
      };
      var getProto = Object.getPrototypeOf;
      var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
      if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
        IteratorPrototype = NativeIteratorPrototype;
      }
      var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
      GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
      GeneratorFunctionPrototype.constructor = GeneratorFunction;
      GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
      function defineIteratorMethods(prototype) {
        ["next", "throw", "return"].forEach(function (method) {
          prototype[method] = function (arg) {
            return this._invoke(method, arg);
          };
        });
      }
      runtime.isGeneratorFunction = function (genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
      };
      runtime.mark = function (genFun) {
        if (Object.setPrototypeOf) {
          Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        } else {
          genFun.__proto__ = GeneratorFunctionPrototype;
          if (!(toStringTagSymbol in genFun)) {
            genFun[toStringTagSymbol] = "GeneratorFunction";
          }
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
      };
      runtime.awrap = function (arg) {
        return {
          __await: arg
        };
      };
      function AsyncIterator(generator) {
        function invoke(method, arg, resolve, reject) {
          var record = tryCatch(generator[method], generator, arg);
          if (record.type === "throw") {
            reject(record.arg);
          } else {
            var result = record.arg;
            var value = result.value;
            if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
              return Promise.resolve(value.__await).then(function (value) {
                invoke("next", value, resolve, reject);
              }, function (err) {
                invoke("throw", err, resolve, reject);
              });
            }
            return Promise.resolve(value).then(function (unwrapped) {
              result.value = unwrapped;
              resolve(result);
            }, reject);
          }
        }
        var previousPromise;
        function enqueue(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new Promise(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }
          return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        this._invoke = enqueue;
      }
      defineIteratorMethods(AsyncIterator.prototype);
      AsyncIterator.prototype[asyncIteratorSymbol] = function () {
        return this;
      };
      runtime.AsyncIterator = AsyncIterator;
      runtime.async = function (innerFn, outerFn, self, tryLocsList) {
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
        return runtime.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
          return result.done ? result.value : iter.next();
        });
      };
      function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
          if (state === GenStateExecuting) {
            throw new Error("Generator is already running");
          }
          if (state === GenStateCompleted) {
            if (method === "throw") {
              throw arg;
            }
            return doneResult();
          }
          context.method = method;
          context.arg = arg;
          while (true) {
            var delegate = context.delegate;
            if (delegate) {
              var delegateResult = maybeInvokeDelegate(delegate, context);
              if (delegateResult) {
                if (delegateResult === ContinueSentinel) continue;
                return delegateResult;
              }
            }
            if (context.method === "next") {
              context.sent = context._sent = context.arg;
            } else if (context.method === "throw") {
              if (state === GenStateSuspendedStart) {
                state = GenStateCompleted;
                throw context.arg;
              }
              context.dispatchException(context.arg);
            } else if (context.method === "return") {
              context.abrupt("return", context.arg);
            }
            state = GenStateExecuting;
            var record = tryCatch(innerFn, self, context);
            if (record.type === "normal") {
              state = context.done ? GenStateCompleted : GenStateSuspendedYield;
              if (record.arg === ContinueSentinel) {
                continue;
              }
              return {
                value: record.arg,
                done: context.done
              };
            } else if (record.type === "throw") {
              state = GenStateCompleted;
              context.method = "throw";
              context.arg = record.arg;
            }
          }
        };
      }
      function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (method === undefined) {
          context.delegate = null;
          if (context.method === "throw") {
            if (delegate.iterator.return) {
              context.method = "return";
              context.arg = undefined;
              maybeInvokeDelegate(delegate, context);
              if (context.method === "throw") {
                return ContinueSentinel;
              }
            }
            context.method = "throw";
            context.arg = new TypeError("The iterator does not provide a 'throw' method");
          }
          return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
          context.method = "throw";
          context.arg = record.arg;
          context.delegate = null;
          return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
          context.method = "throw";
          context.arg = new TypeError("iterator result is not an object");
          context.delegate = null;
          return ContinueSentinel;
        }
        if (info.done) {
          context[delegate.resultName] = info.value;
          context.next = delegate.nextLoc;
          if (context.method !== "return") {
            context.method = "next";
            context.arg = undefined;
          }
        } else {
          return info;
        }
        context.delegate = null;
        return ContinueSentinel;
      }
      defineIteratorMethods(Gp);
      Gp[toStringTagSymbol] = "Generator";
      Gp[iteratorSymbol] = function () {
        return this;
      };
      Gp.toString = function () {
        return "[object Generator]";
      };
      function pushTryEntry(locs) {
        var entry = {
          tryLoc: locs[0]
        };
        if (1 in locs) {
          entry.catchLoc = locs[1];
        }
        if (2 in locs) {
          entry.finallyLoc = locs[2];
          entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
      }
      function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
      }
      function Context(tryLocsList) {
        this.tryEntries = [{
          tryLoc: "root"
        }];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
      }
      runtime.keys = function (object) {
        var keys = [];
        for (var key in object) {
          keys.push(key);
        }
        keys.reverse();
        return function next() {
          while (keys.length) {
            var key = keys.pop();
            if (key in object) {
              next.value = key;
              next.done = false;
              return next;
            }
          }
          next.done = true;
          return next;
        };
      };
      function values(iterable) {
        if (iterable) {
          var iteratorMethod = iterable[iteratorSymbol];
          if (iteratorMethod) {
            return iteratorMethod.call(iterable);
          }
          if (typeof iterable.next === "function") {
            return iterable;
          }
          if (!isNaN(iterable.length)) {
            var i = -1, next = function next() {
              while (++i < iterable.length) {
                if (hasOwn.call(iterable, i)) {
                  next.value = iterable[i];
                  next.done = false;
                  return next;
                }
              }
              next.value = undefined;
              next.done = true;
              return next;
            };
            return next.next = next;
          }
        }
        return {
          next: doneResult
        };
      }
      runtime.values = values;
      function doneResult() {
        return {
          value: undefined,
          done: true
        };
      }
      Context.prototype = {
        constructor: Context,
        reset: function (skipTempReset) {
          this.prev = 0;
          this.next = 0;
          this.sent = this._sent = undefined;
          this.done = false;
          this.delegate = null;
          this.method = "next";
          this.arg = undefined;
          this.tryEntries.forEach(resetTryEntry);
          if (!skipTempReset) {
            for (var name in this) {
              if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                this[name] = undefined;
              }
            }
          }
        },
        stop: function () {
          this.done = true;
          var rootEntry = this.tryEntries[0];
          var rootRecord = rootEntry.completion;
          if (rootRecord.type === "throw") {
            throw rootRecord.arg;
          }
          return this.rval;
        },
        dispatchException: function (exception) {
          if (this.done) {
            throw exception;
          }
          var context = this;
          function handle(loc, caught) {
            record.type = "throw";
            record.arg = exception;
            context.next = loc;
            if (caught) {
              context.method = "next";
              context.arg = undefined;
            }
            return !!caught;
          }
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            var record = entry.completion;
            if (entry.tryLoc === "root") {
              return handle("end");
            }
            if (entry.tryLoc <= this.prev) {
              var hasCatch = hasOwn.call(entry, "catchLoc");
              var hasFinally = hasOwn.call(entry, "finallyLoc");
              if (hasCatch && hasFinally) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                } else if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else if (hasCatch) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                }
              } else if (hasFinally) {
                if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else {
                throw new Error("try statement without catch or finally");
              }
            }
          }
        },
        abrupt: function (type, arg) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
              var finallyEntry = entry;
              break;
            }
          }
          if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
            finallyEntry = null;
          }
          var record = finallyEntry ? finallyEntry.completion : {};
          record.type = type;
          record.arg = arg;
          if (finallyEntry) {
            this.method = "next";
            this.next = finallyEntry.finallyLoc;
            return ContinueSentinel;
          }
          return this.complete(record);
        },
        complete: function (record, afterLoc) {
          if (record.type === "throw") {
            throw record.arg;
          }
          if (record.type === "break" || record.type === "continue") {
            this.next = record.arg;
          } else if (record.type === "return") {
            this.rval = this.arg = record.arg;
            this.method = "return";
            this.next = "end";
          } else if (record.type === "normal" && afterLoc) {
            this.next = afterLoc;
          }
          return ContinueSentinel;
        },
        finish: function (finallyLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.finallyLoc === finallyLoc) {
              this.complete(entry.completion, entry.afterLoc);
              resetTryEntry(entry);
              return ContinueSentinel;
            }
          }
        },
        catch: function (tryLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.tryLoc === tryLoc) {
              var record = entry.completion;
              if (record.type === "throw") {
                var thrown = record.arg;
                resetTryEntry(entry);
              }
              return thrown;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function (iterable, resultName, nextLoc) {
          this.delegate = {
            iterator: values(iterable),
            resultName: resultName,
            nextLoc: nextLoc
          };
          if (this.method === "next") {
            this.arg = undefined;
          }
          return ContinueSentinel;
        }
      };
    }(function () {
      return this;
    }() || Function("return this")());
  });
  (function (global) {
    var checkIfIteratorIsSupported = function () {
      try {
        return !!Symbol.iterator;
      } catch (error) {
        return false;
      }
    };
    var iteratorSupported = checkIfIteratorIsSupported();
    var createIterator = function (items) {
      var iterator = {
        next: function () {
          var value = items.shift();
          return {
            done: value === void 0,
            value: value
          };
        }
      };
      if (iteratorSupported) {
        iterator[Symbol.iterator] = function () {
          return iterator;
        };
      }
      return iterator;
    };
    var serializeParam = function (value) {
      return encodeURIComponent(value).replace(/%20/g, "+");
    };
    var deserializeParam = function (value) {
      return decodeURIComponent(String(value).replace(/\+/g, " "));
    };
    var polyfillURLSearchParams = function () {
      var URLSearchParams = function (searchString) {
        Object.defineProperty(this, "_entries", {
          writable: true,
          value: {}
        });
        var typeofSearchString = typeof searchString;
        if (typeofSearchString === "undefined"); else if (typeofSearchString === "string") {
          if (searchString !== "") {
            this._fromString(searchString);
          }
        } else if (searchString instanceof URLSearchParams) {
          var _this = this;
          searchString.forEach(function (value, name) {
            _this.append(name, value);
          });
        } else if (searchString !== null && typeofSearchString === "object") {
          if (Object.prototype.toString.call(searchString) === "[object Array]") {
            for (var i = 0; i < searchString.length; i++) {
              var entry = searchString[i];
              if (Object.prototype.toString.call(entry) === "[object Array]" || entry.length !== 2) {
                this.append(entry[0], entry[1]);
              } else {
                throw new TypeError("Expected [string, any] as entry at index " + i + " of URLSearchParams's input");
              }
            }
          } else {
            for (var key in searchString) {
              if (searchString.hasOwnProperty(key)) {
                this.append(key, searchString[key]);
              }
            }
          }
        } else {
          throw new TypeError("Unsupported input's type for URLSearchParams");
        }
      };
      var proto = URLSearchParams.prototype;
      proto.append = function (name, value) {
        if (name in this._entries) {
          this._entries[name].push(String(value));
        } else {
          this._entries[name] = [String(value)];
        }
      };
      proto.delete = function (name) {
        delete this._entries[name];
      };
      proto.get = function (name) {
        return name in this._entries ? this._entries[name][0] : null;
      };
      proto.getAll = function (name) {
        return name in this._entries ? this._entries[name].slice(0) : [];
      };
      proto.has = function (name) {
        return name in this._entries;
      };
      proto.set = function (name, value) {
        this._entries[name] = [String(value)];
      };
      proto.forEach = function (callback, thisArg) {
        var entries;
        for (var name in this._entries) {
          if (this._entries.hasOwnProperty(name)) {
            entries = this._entries[name];
            for (var i = 0; i < entries.length; i++) {
              callback.call(thisArg, entries[i], name, this);
            }
          }
        }
      };
      proto.keys = function () {
        var items = [];
        this.forEach(function (value, name) {
          items.push(name);
        });
        return createIterator(items);
      };
      proto.values = function () {
        var items = [];
        this.forEach(function (value) {
          items.push(value);
        });
        return createIterator(items);
      };
      proto.entries = function () {
        var items = [];
        this.forEach(function (value, name) {
          items.push([name, value]);
        });
        return createIterator(items);
      };
      if (iteratorSupported) {
        proto[Symbol.iterator] = proto.entries;
      }
      proto.toString = function () {
        var searchArray = [];
        this.forEach(function (value, name) {
          searchArray.push(serializeParam(name) + "=" + serializeParam(value));
        });
        return searchArray.join("&");
      };
      global.URLSearchParams = URLSearchParams;
    };
    var checkIfURLSearchParamsSupported = function () {
      try {
        var URLSearchParams = global.URLSearchParams;
        return new URLSearchParams("?a=1").toString() === "a=1" && typeof URLSearchParams.prototype.set === "function";
      } catch (e) {
        return false;
      }
    };
    if (!checkIfURLSearchParamsSupported()) {
      polyfillURLSearchParams();
    }
    var proto = global.URLSearchParams.prototype;
    if (typeof proto.sort !== "function") {
      proto.sort = function () {
        var _this = this;
        var items = [];
        this.forEach(function (value, name) {
          items.push([name, value]);
          if (!_this._entries) {
            _this.delete(name);
          }
        });
        items.sort(function (a, b) {
          if (a[0] < b[0]) {
            return -1;
          } else if (a[0] > b[0]) {
            return +1;
          } else {
            return 0;
          }
        });
        if (_this._entries) {
          _this._entries = {};
        }
        for (var i = 0; i < items.length; i++) {
          this.append(items[i][0], items[i][1]);
        }
      };
    }
    if (typeof proto._fromString !== "function") {
      Object.defineProperty(proto, "_fromString", {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function (searchString) {
          if (this._entries) {
            this._entries = {};
          } else {
            var keys = [];
            this.forEach(function (value, name) {
              keys.push(name);
            });
            for (var i = 0; i < keys.length; i++) {
              this.delete(keys[i]);
            }
          }
          searchString = searchString.replace(/^\?/, "");
          var attributes = searchString.split("&");
          var attribute;
          for (var i = 0; i < attributes.length; i++) {
            attribute = attributes[i].split("=");
            this.append(deserializeParam(attribute[0]), attribute.length > 1 ? deserializeParam(attribute[1]) : "");
          }
        }
      });
    }
  })(typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : commonjsGlobal);
  (function (global) {
    var checkIfURLIsSupported = function () {
      try {
        var u = new global.URL("b", "http://a");
        u.pathname = "c%20d";
        return u.href === "http://a/c%20d" && u.searchParams;
      } catch (e) {
        return false;
      }
    };
    var polyfillURL = function () {
      var _URL = global.URL;
      var URL = function (url, base) {
        if (typeof url !== "string") url = String(url);
        var doc = document, baseElement;
        if (base && (global.location === void 0 || base !== global.location.href)) {
          doc = document.implementation.createHTMLDocument("");
          baseElement = doc.createElement("base");
          baseElement.href = base;
          doc.head.appendChild(baseElement);
          try {
            if (baseElement.href.indexOf(base) !== 0) throw new Error(baseElement.href);
          } catch (err) {
            throw new Error("URL unable to set base " + base + " due to " + err);
          }
        }
        var anchorElement = doc.createElement("a");
        anchorElement.href = url;
        if (baseElement) {
          doc.body.appendChild(anchorElement);
          anchorElement.href = anchorElement.href;
        }
        if (anchorElement.protocol === ":" || !/:/.test(anchorElement.href)) {
          throw new TypeError("Invalid URL");
        }
        Object.defineProperty(this, "_anchorElement", {
          value: anchorElement
        });
        var searchParams = new global.URLSearchParams(this.search);
        var enableSearchUpdate = true;
        var enableSearchParamsUpdate = true;
        var _this = this;
        ["append", "delete", "set"].forEach(function (methodName) {
          var method = searchParams[methodName];
          searchParams[methodName] = function () {
            method.apply(searchParams, arguments);
            if (enableSearchUpdate) {
              enableSearchParamsUpdate = false;
              _this.search = searchParams.toString();
              enableSearchParamsUpdate = true;
            }
          };
        });
        Object.defineProperty(this, "searchParams", {
          value: searchParams,
          enumerable: true
        });
        var search = void 0;
        Object.defineProperty(this, "_updateSearchParams", {
          enumerable: false,
          configurable: false,
          writable: false,
          value: function () {
            if (this.search !== search) {
              search = this.search;
              if (enableSearchParamsUpdate) {
                enableSearchUpdate = false;
                this.searchParams._fromString(this.search);
                enableSearchUpdate = true;
              }
            }
          }
        });
      };
      var proto = URL.prototype;
      var linkURLWithAnchorAttribute = function (attributeName) {
        Object.defineProperty(proto, attributeName, {
          get: function () {
            return this._anchorElement[attributeName];
          },
          set: function (value) {
            this._anchorElement[attributeName] = value;
          },
          enumerable: true
        });
      };
      ["hash", "host", "hostname", "port", "protocol"].forEach(function (attributeName) {
        linkURLWithAnchorAttribute(attributeName);
      });
      Object.defineProperty(proto, "search", {
        get: function () {
          return this._anchorElement["search"];
        },
        set: function (value) {
          this._anchorElement["search"] = value;
          this._updateSearchParams();
        },
        enumerable: true
      });
      Object.defineProperties(proto, {
        toString: {
          get: function () {
            var _this = this;
            return function () {
              return _this.href;
            };
          }
        },
        href: {
          get: function () {
            return this._anchorElement.href.replace(/\?$/, "");
          },
          set: function (value) {
            this._anchorElement.href = value;
            this._updateSearchParams();
          },
          enumerable: true
        },
        pathname: {
          get: function () {
            return this._anchorElement.pathname.replace(/(^\/?)/, "/");
          },
          set: function (value) {
            this._anchorElement.pathname = value;
          },
          enumerable: true
        },
        origin: {
          get: function () {
            var expectedPort = {
              "http:": 80,
              "https:": 443,
              "ftp:": 21
            }[this._anchorElement.protocol];
            var addPortToOrigin = this._anchorElement.port != expectedPort && this._anchorElement.port !== "";
            return this._anchorElement.protocol + "//" + this._anchorElement.hostname + (addPortToOrigin ? ":" + this._anchorElement.port : "");
          },
          enumerable: true
        },
        password: {
          get: function () {
            return "";
          },
          set: function (value) { },
          enumerable: true
        },
        username: {
          get: function () {
            return "";
          },
          set: function (value) { },
          enumerable: true
        }
      });
      URL.createObjectURL = function (blob) {
        return _URL.createObjectURL.apply(_URL, arguments);
      };
      URL.revokeObjectURL = function (url) {
        return _URL.revokeObjectURL.apply(_URL, arguments);
      };
      global.URL = URL;
    };
    if (!checkIfURLIsSupported()) {
      polyfillURL();
    }
    if (global.location !== void 0 && !("origin" in global.location)) {
      var getOrigin = function () {
        return global.location.protocol + "//" + global.location.hostname + (global.location.port ? ":" + global.location.port : "");
      };
      try {
        Object.defineProperty(global.location, "origin", {
          get: getOrigin,
          enumerable: true
        });
      } catch (e) {
        setInterval(function () {
          global.location.origin = getOrigin();
        }, 100);
      }
    }
  })(typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : commonjsGlobal);
  var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
  function symbolObservablePonyfill(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
      if (Symbol.observable) {
        result = Symbol.observable;
      } else {
        result = Symbol("observable");
        Symbol.observable = result;
      }
    } else {
      result = "@@observable";
    }
    return result;
  }
  var root;
  if (typeof self !== "undefined") {
    root = self;
  } else if (typeof window !== "undefined") {
    root = window;
  } else if (typeof global$1 !== "undefined") {
    root = global$1;
  } else if (typeof module !== "undefined") {
    root = module;
  } else {
    root = Function("return this")();
  }
  var result = symbolObservablePonyfill(root);
  var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
  };
  var ActionTypes = {
    INIT: "@@redux/INIT" + randomString(),
    REPLACE: "@@redux/REPLACE" + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
      return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
    }
  };
  function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while (Object.getPrototypeOf(proto) !== null) {
      proto = Object.getPrototypeOf(proto);
    }
    return Object.getPrototypeOf(obj) === proto;
  }
  function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
      throw new Error("It looks like you are passing several store enhancers to " + "createStore(). This is not supported. Instead, compose them " + "together to a single function");
    }
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
      enhancer = preloadedState;
      preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
      if (typeof enhancer !== "function") {
        throw new Error("Expected the enhancer to be a function.");
      }
      return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") {
      throw new Error("Expected the reducer to be a function.");
    }
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
      if (nextListeners === currentListeners) {
        nextListeners = currentListeners.slice();
      }
    }
    function getState() {
      if (isDispatching) {
        throw new Error("You may not call store.getState() while the reducer is executing. " + "The reducer has already received the state as an argument. " + "Pass it down from the top reducer instead of reading it from the store.");
      }
      return currentState;
    }
    function subscribe(listener) {
      if (typeof listener !== "function") {
        throw new Error("Expected the listener to be a function.");
      }
      if (isDispatching) {
        throw new Error("You may not call store.subscribe() while the reducer is executing. " + "If you would like to be notified after the store has been updated, subscribe from a " + "component and invoke store.getState() in the callback to access the latest state. " + "See https://redux.js.org/api-reference/store#subscribe(listener) for more details.");
      }
      var isSubscribed = true;
      ensureCanMutateNextListeners();
      nextListeners.push(listener);
      return function unsubscribe() {
        if (!isSubscribed) {
          return;
        }
        if (isDispatching) {
          throw new Error("You may not unsubscribe from a store listener while the reducer is executing. " + "See https://redux.js.org/api-reference/store#subscribe(listener) for more details.");
        }
        isSubscribed = false;
        ensureCanMutateNextListeners();
        var index = nextListeners.indexOf(listener);
        nextListeners.splice(index, 1);
      };
    }
    function dispatch(action) {
      if (!isPlainObject(action)) {
        throw new Error("Actions must be plain objects. " + "Use custom middleware for async actions.");
      }
      if (typeof action.type === "undefined") {
        throw new Error('Actions may not have an undefined "type" property. ' + "Have you misspelled a constant?");
      }
      if (isDispatching) {
        throw new Error("Reducers may not dispatch actions.");
      }
      try {
        isDispatching = true;
        currentState = currentReducer(currentState, action);
      } finally {
        isDispatching = false;
      }
      var listeners = currentListeners = nextListeners;
      for (var i = 0; i < listeners.length; i++) {
        var listener = listeners[i];
        listener();
      }
      return action;
    }
    function replaceReducer(nextReducer) {
      if (typeof nextReducer !== "function") {
        throw new Error("Expected the nextReducer to be a function.");
      }
      currentReducer = nextReducer;
      dispatch({
        type: ActionTypes.REPLACE
      });
    }
    function observable() {
      var _ref;
      var outerSubscribe = subscribe;
      return _ref = {
        subscribe: function subscribe(observer) {
          if (typeof observer !== "object" || observer === null) {
            throw new TypeError("Expected the observer to be an object.");
          }
          function observeState() {
            if (observer.next) {
              observer.next(getState());
            }
          }
          observeState();
          var unsubscribe = outerSubscribe(observeState);
          return {
            unsubscribe: unsubscribe
          };
        }
      }, _ref[result] = function () {
        return this;
      }, _ref;
    }
    dispatch({
      type: ActionTypes.INIT
    });
    return _ref2 = {
      dispatch: dispatch,
      subscribe: subscribe,
      getState: getState,
      replaceReducer: replaceReducer
    }, _ref2[result] = observable, _ref2;
  }
  function getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionDescription = actionType && 'action "' + String(actionType) + '"' || "an action";
    return "Given " + actionDescription + ', reducer "' + key + '" returned undefined. ' + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
  }
  function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function (key) {
      var reducer = reducers[key];
      var initialState = reducer(undefined, {
        type: ActionTypes.INIT
      });
      if (typeof initialState === "undefined") {
        throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
      }
      if (typeof reducer(undefined, {
        type: ActionTypes.PROBE_UNKNOWN_ACTION()
      }) === "undefined") {
        throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ("Don't try to handle " + ActionTypes.INIT + ' or other actions in "redux/*" ') + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
      }
    });
  }
  function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for (var i = 0; i < reducerKeys.length; i++) {
      var key = reducerKeys[i];
      if (typeof reducers[key] === "function") {
        finalReducers[key] = reducers[key];
      }
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var shapeAssertionError;
    try {
      assertReducerShape(finalReducers);
    } catch (e) {
      shapeAssertionError = e;
    }
    return function combination(state, action) {
      if (state === void 0) {
        state = {};
      }
      if (shapeAssertionError) {
        throw shapeAssertionError;
      }
      var hasChanged = false;
      var nextState = {};
      for (var _i = 0; _i < finalReducerKeys.length; _i++) {
        var _key = finalReducerKeys[_i];
        var reducer = finalReducers[_key];
        var previousStateForKey = state[_key];
        var nextStateForKey = reducer(previousStateForKey, action);
        if (typeof nextStateForKey === "undefined") {
          var errorMessage = getUndefinedStateErrorMessage(_key, action);
          throw new Error(errorMessage);
        }
        nextState[_key] = nextStateForKey;
        hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
      }
      return hasChanged ? nextState : state;
    };
  }
  function bindActionCreator(actionCreator, dispatch) {
    return function () {
      return dispatch(actionCreator.apply(this, arguments));
    };
  }
  function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === "function") {
      return bindActionCreator(actionCreators, dispatch);
    }
    if (typeof actionCreators !== "object" || actionCreators === null) {
      throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? "null" : typeof actionCreators) + ". " + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    }
    var keys = Object.keys(actionCreators);
    var boundActionCreators = {};
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var actionCreator = actionCreators[key];
      if (typeof actionCreator === "function") {
        boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
      }
    }
    return boundActionCreators;
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);
      if (typeof Object.getOwnPropertySymbols === "function") {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }
      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }
    return target;
  }
  function compose() {
    for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
      funcs[_key] = arguments[_key];
    }
    if (funcs.length === 0) {
      return function (arg) {
        return arg;
      };
    }
    if (funcs.length === 1) {
      return funcs[0];
    }
    return funcs.reduce(function (a, b) {
      return function () {
        return a(b.apply(void 0, arguments));
      };
    });
  }
  function applyMiddleware() {
    for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
      middlewares[_key] = arguments[_key];
    }
    return function (createStore) {
      return function () {
        var store = createStore.apply(void 0, arguments);
        var _dispatch = function dispatch() {
          throw new Error("Dispatching while constructing your middleware is not allowed. " + "Other middleware would not be applied to this dispatch.");
        };
        var middlewareAPI = {
          getState: store.getState,
          dispatch: function dispatch() {
            return _dispatch.apply(void 0, arguments);
          }
        };
        var chain = middlewares.map(function (middleware) {
          return middleware(middlewareAPI);
        });
        _dispatch = compose.apply(void 0, chain)(store.dispatch);
        return _objectSpread({}, store, {
          dispatch: _dispatch
        });
      };
    };
  }
  var redux = Object.freeze({
    createStore: createStore,
    combineReducers: combineReducers,
    bindActionCreators: bindActionCreators,
    applyMiddleware: applyMiddleware,
    compose: compose,
    __DO_NOT_USE__ActionTypes: ActionTypes
  });
  var reduxDevtoolsExtension = createCommonjsModule(function (module, exports) {
    var compose = redux.compose;
    exports.__esModule = true;
    exports.composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === "object") return compose;
      return compose.apply(null, arguments);
    };
    exports.devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
      return function (noop) {
        return noop;
      };
    };
  });
  unwrapExports(reduxDevtoolsExtension);
  var reduxDevtoolsExtension_1 = reduxDevtoolsExtension.composeWithDevTools;
  var reduxDevtoolsExtension_2 = reduxDevtoolsExtension.devToolsEnhancer;
  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }
    return _typeof(obj);
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
  }
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
      return arr2;
    }
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }
  function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
  var isArray = function (input) {
    return Array.isArray(input);
  };
  var isPlainObject$1 = function (input) {
    return Object.prototype.toString.call(input) === "[object Object]";
  };
  var isEmpty = function (input) {
    switch (_typeof(input)) {
      case "string":
        return input.trim() === "";

      case "number":
        return parseInt("".concat(input), 10) === 0;

      default:
        if (isArray(input)) {
          return input.length === 0;
        }
        if (isPlainObject$1(input)) {
          return Object.keys(input).length === 0;
        }
        return input == null;
    }
  };
  var isUndefined = function (input) {
    return typeof input === "undefined";
  };
  function deepMerge() {
    var newObj = {};
    function merge(obj) {
      if (isEmpty(obj) || isUndefined(obj)) {
        return;
      }
      Object.keys(obj).forEach(function (prop) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
          if (isPlainObject$1(obj[prop])) {
            newObj[prop] = deepMerge(newObj[prop], obj[prop]);
          } else {
            newObj[prop] = obj[prop];
          }
        }
      });
    }
    for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
      objects[_key] = arguments[_key];
    }
    objects.forEach(merge);
    return newObj;
  }
  var escape = function (string) {
    var str = "".concat(string);
    var match = /["'&<>]/.exec(str);
    if (!match) {
      return str;
    }
    var escape;
    var html = "";
    var index = match.index;
    var lastIndex = 0;
    for (index; index < str.length; index += 1) {
      switch (str.charCodeAt(index)) {
        case 34:
          escape = "&quot;";
          break;

        case 38:
          escape = "&amp;";
          break;

        case 39:
          escape = "&#39;";
          break;

        case 60:
          escape = "&lt;";
          break;

        case 62:
          escape = "&gt;";
          break;

        default:
          continue;
      }
      if (lastIndex !== index) {
        html += str.substring(lastIndex, index);
      }
      lastIndex = index + 1;
      html += escape;
    }
    return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
  };
  var isString = function (input) {
    return typeof input === "string";
  };
  var hasOwnProperty$1 = function (obj, prop) {
    if (!isString(prop)) {
      return false;
    }
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
  var ADD_OBSERVER = "ADD_OBSERVER";
  var ADD_VARS = "ADD_VARS";
  var DEQUEUE = "DEQUEUE";
  var ENQUEUE = "ENQUEUE";
  var INCREMENT_UID = "INCREMENT_UID";
  var INITIALIZE = "INITIALIZE";
  var MAP_DATA = "MAP_DATA";
  var REMOVE_EVENT = "REMOVE_EVENT";
  var SCRIPT_PATH = "SCRIPT_PATH";
  var SOURCECACHE = "SOURCECACHE";
  var initialState = {
    data: {},
    initialized: false,
    observers: {},
    queue: [],
    scriptPath: "./",
    sourceCache: {},
    uid: 1,
    vars: {}
  };
  function cache(state, action) {
    switch (action.type) {
      case ADD_OBSERVER:
        if (action.name && action.observer) {
          state.observers[action.name] = action.observer;
        }
        return state;

      case ADD_VARS:
        if (isPlainObject$1(action.vars)) {
          state.vars = deepMerge(state.vars, action.vars);
        }
        return state;

      case DEQUEUE:
        if (state.queue.length > 0) {
          state.queue.shift();
        }
        return state;

      case ENQUEUE:
        if (isPlainObject$1(action.source)) {
          state.queue.push(action.source);
        }
        return state;

      case INCREMENT_UID:
        state.uid += 1;
        return state;

      case INITIALIZE:
        state.initialized = true;
        return state;

      case MAP_DATA:
        if (!hasOwnProperty$1(state.data, action.uid) && isPlainObject$1(action.data)) {
          state.data[action.uid] = action.data;
        }
        return state;

      case REMOVE_EVENT:
        if (action.uid && action.uid in state.data) {
          delete state.data[action.uid];
        }
        return state;

      case SOURCECACHE:
        if (isPlainObject$1(action.source)) {
          state.sourceCache = deepMerge(state.sourceCache, action.source);
        }
        return state;

      case SCRIPT_PATH:
        if (isString(action.path)) {
          var paths = action.path.split("/").map(function (part) {
            return escape(part.replace(/https?:|\?/gi, ""));
          }).filter(function (part) {
            return part != null && part.length > 0;
          });
          state.scriptPath = paths.join("/");
        }
        return state;

      default:
        return state;
    }
  }
  var store = createStore(cache, initialState, reduxDevtoolsExtension_2());
  var INTEGER = {
    type: "integer",
    required: false
  };
  var NUMBER$2 = {
    type: "number",
    required: false
  };
  var STRING = {
    type: "string",
    required: false
  };
  var BOOLEAN = {
    type: "boolean",
    required: false
  };
  var ARRAY_OF_STRINGS = {
    type: "array",
    required: false,
    items: STRING
  };
  var FILTER = {
    type: "object",
    required: false,
    properties: {
      type: STRING,
      value: STRING
    }
  };
  var FORM_CONTEXT = {
    type: "object",
    required: false,
    properties: {
      formName: STRING,
      formId: STRING,
      formType: STRING
    }
  };
  var PRODUCT = {
    type: "object",
    required: false,
    properties: {
      brand: STRING,
      category: STRING,
      coupon: STRING,
      formatSubtype: STRING,
      formatType: STRING,
      location: STRING,
      name: STRING,
      pageId: STRING,
      position: INTEGER,
      price: NUMBER$2,
      productId: STRING,
      quantity: INTEGER,
      sku: STRING,
      subscription: {
        type: "object",
        required: false,
        properties: {
          frequency: STRING
        }
      },
      text: STRING,
      upc: STRING,
      variant: STRING
    }
  };
  var STEP_CONTEXT = {
    type: "object",
    required: false,
    properties: {
      stepId: STRING,
      stepName: STRING,
      stepType: STRING
    }
  };
  var FIELD = {
    type: "object",
    required: false,
    properties: {
      autofilled: BOOLEAN,
      fieldId: STRING,
      fieldLabel: STRING,
      fieldName: STRING,
      fieldType: STRING,
      fieldValue: STRING
    }
  };
  var WEB_ELEMENT = {
    type: "object",
    required: false,
    properties: {
      elementType: STRING,
      htmlId: STRING,
      location: STRING,
      name: STRING,
      position: STRING,
      text: STRING
    }
  };
  var schemas = {
    Alias: {
      type: STRING,
      alias: STRING
    },
    ApplicationClicked: {
      actionOutcome: STRING,
      applicationType: STRING,
      webElement: WEB_ELEMENT
    },
    CartViewed: {},
    CheckoutStarted: {},
    ContentMetadataTracked: {
      author: STRING,
      category: STRING,
      contentName: STRING,
      funnelStage: STRING,
      lastRefreshDate: STRING,
      objective: ARRAY_OF_STRINGS,
      publishDate: STRING,
      siteSection: STRING,
      tags: ARRAY_OF_STRINGS,
      targetAudience: STRING
    },
    ElementClicked: {
      actionOutcome: STRING,
      correlationId: STRING,
      outboundUrl: STRING,
      webElement: WEB_ELEMENT
    },
    ElementSwiped: {
      actionOutcome: STRING,
      webElement: WEB_ELEMENT
    },
    ElementViewed: {
      webElement: WEB_ELEMENT
    },
    FieldInputted: {
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT,
      userInputField: FIELD
    },
    FieldSelected: {
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT,
      userInputField: FIELD
    },
    FormBacked: {
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT
    },
    FormContinued: {
      autofillUsed: BOOLEAN,
      correlationId: STRING,
      field: FIELD,
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT
    },
    FormErrored: {
      errorDetails: STRING,
      errorMessage: STRING,
      errorType: STRING,
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT
    },
    FormExited: {
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT
    },
    FormOutcomeReceived: {
      correlationId: STRING,
      formContext: FORM_CONTEXT,
      outboundUrl: STRING,
      responseDescription: STRING,
      responseMessage: STRING
    },
    FormRestarted: {
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT
    },
    FormStarted: {
      correlationId: STRING,
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT
    },
    FormSubmitted: {
      autofillUsed: BOOLEAN,
      correlationId: STRING,
      field: {
        type: "array",
        required: false,
        items: FIELD
      },
      formContext: FORM_CONTEXT,
      outboundUrl: STRING,
      stepContext: STEP_CONTEXT
    },
    FormViewed: {
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT
    },
    HopPageViewed: {
      affiliateId: INTEGER,
      categoryId: INTEGER,
      correlationId: STRING,
      omnitureId: INTEGER,
      omnitureIdString: STRING,
      pageId: INTEGER,
      position: STRING,
      productId: INTEGER,
      purchaseId: INTEGER
    },
    ListFiltered: {
      listId: STRING,
      listName: STRING,
      listType: STRING,
      location: STRING,
      position: STRING,
      value: STRING
    },
    PageErrored: {
      errorMessage: STRING,
      errorType: STRING,
      urlEntered: STRING
    },
    PageScrolled: {
      scrollDistance: NUMBER$2
    },
    PageViewed: {},
    PageEngaged: {
      engagementDuration: INTEGER,
      totalDuration: INTEGER
    },
    ProductAdded: {
      correlationId: STRING,
      listId: STRING,
      product: PRODUCT
    },
    ProductClicked: {
      actionOutcome: STRING,
      correlationId: STRING,
      listId: STRING,
      outboundUrl: STRING,
      product: PRODUCT,
      viewCorrelationId: STRING
    },
    ProductListFiltered: {
      field: {
        type: "array",
        required: false,
        items: FIELD
      },
      filters: {
        type: "array",
        required: false,
        items: FILTER
      },
      listId: INTEGER,
      product: {
        type: "array",
        required: false,
        items: PRODUCT
      },
      sorts: {
        type: "array",
        required: false,
        items: FILTER
      }
    },
    ProductListViewed: {
      category: STRING,
      editorialListings: INTEGER,
      featuredListings: INTEGER,
      field: {
        type: "array",
        required: false,
        items: FIELD
      },
      listId: STRING,
      listName: STRING,
      paidListings: INTEGER,
      product: {
        type: "array",
        required: false,
        items: PRODUCT
      },
      reasonNoCoverage: STRING,
      sponsoredListings: INTEGER,
      standardListings: INTEGER
    },
    ProductRemoved: {
      product: PRODUCT
    },
    ProductSearched: {
      field: FIELD,
      listId: STRING,
      query: STRING
    },
    ProductViewed: {
      listId: STRING,
      product: PRODUCT,
      viewCorrelationId: STRING
    }
  };
  var eventsList = {
    Alias: {
      type: "core.Alias.v1",
      event: "click",
      schema: schemas.Alias
    },
    ApplicationClicked: {
      type: "redventures.usertracking.v3.ApplicationClicked",
      event: "click",
      schema: schemas.ApplicationClicked
    },
    CartViewed: {
      type: "redventures.ecommerce.v1.CartViewed",
      event: "view",
      schema: schemas.CartViewed
    },
    CheckoutStarted: {
      type: "redventures.ecommerce.v1.CheckoutStarted",
      event: "click",
      schema: schemas.CheckoutStarted
    },
    ContentMetadataTracked: {
      type: "redventures.usertracking.v3.ContentMetadataTracked",
      event: "view",
      schema: schemas.ContentMetadataTracked
    },
    ElementClicked: {
      type: "redventures.usertracking.v3.ElementClicked",
      event: "click",
      schema: schemas.ElementClicked
    },
    ElementSwiped: {
      type: "redventures.usertracking.v3.ElementSwiped",
      event: "swipe",
      schema: schemas.ElementSwiped
    },
    ElementViewed: {
      type: "redventures.usertracking.v3.ElementViewed",
      event: "view",
      schema: schemas.ElementViewed
    },
    FieldInputted: {
      type: "redventures.usertracking.v3.FieldInputted",
      event: "change",
      schema: schemas.FieldInputted
    },
    FieldSelected: {
      type: "redventures.usertracking.v3.FieldSelected",
      event: "change",
      schema: schemas.FieldSelected
    },
    FormBacked: {
      type: "redventures.usertracking.v3.FormBacked",
      event: "click",
      schema: schemas.FormBacked
    },
    FormContinued: {
      type: "redventures.usertracking.v3.FormContinued",
      event: "click",
      schema: schemas.FormContinued
    },
    FormErrored: {
      type: "redventures.usertracking.v3.FormErrored",
      event: "view",
      schema: schemas.FormErrored
    },
    FormExited: {
      type: "redventures.usertracking.v3.FormExited",
      event: "click",
      schema: schemas.FormExited
    },
    FormOutcomeReceived: {
      type: "redventures.usertracking.v3.FormOutcomeReceived",
      event: "view",
      schema: schemas.FormOutcomeReceived
    },
    FormRestarted: {
      type: "redventures.usertracking.v3.FormRestarted",
      event: "click",
      schema: schemas.FormRestarted
    },
    FormStarted: {
      type: "redventures.usertracking.v3.FormStarted",
      event: "click",
      schema: schemas.FormStarted
    },
    FormSubmitted: {
      type: "redventures.usertracking.v3.FormSubmitted",
      event: "submit",
      schema: schemas.FormSubmitted
    },
    FormViewed: {
      type: "redventures.usertracking.v3.FormViewed",
      event: "view",
      schema: schemas.FormViewed
    },
    HopPageViewed: {
      type: "redventures.creditcards.v1.HopPageViewed",
      event: "view",
      schema: schemas.HopPageViewed
    },
    ListFiltered: {
      type: "redventures.usertracking.v3.ListFiltered",
      event: "click",
      schema: schemas.ListFiltered
    },
    PageErrored: {
      type: "redventures.usertracking.v3.PageErrored",
      event: "view",
      schema: schemas.PageErrored
    },
    PageScrolled: {
      type: "redventures.usertracking.v3.PageScrolled",
      event: "scroll",
      schema: schemas.PageScrolled
    },
    PageViewed: {
      type: "redventures.usertracking.v3.PageViewed",
      event: "view",
      schema: schemas.PageViewed
    },
    PageEngaged: {
      type: "redventures.usertracking.v3.PageEngaged",
      event: "click",
      schema: schemas.PageEngaged
    },
    ProductAdded: {
      type: "redventures.ecommerce.v1.ProductAdded",
      event: "click",
      schema: schemas.ProductAdded
    },
    ProductClicked: {
      type: "redventures.ecommerce.v1.ProductClicked",
      event: "click",
      schema: schemas.ProductClicked
    },
    ProductListFiltered: {
      type: "redventures.ecommerce.v1.ProductListFiltered",
      event: "click",
      schema: schemas.ProductListFiltered
    },
    ProductListViewed: {
      type: "redventures.ecommerce.v1.ProductListViewed",
      event: "view",
      schema: schemas.ProductListViewed
    },
    ProductRemoved: {
      type: "redventures.ecommerce.v1.ProductRemoved",
      event: "click",
      schema: schemas.ProductRemoved
    },
    ProductSearched: {
      type: "redventures.ecommerce.v1.ProductSearched",
      event: "click",
      schema: schemas.ProductSearched
    },
    ProductViewed: {
      type: "redventures.ecommerce.v1.ProductViewed",
      event: "view",
      schema: schemas.ProductViewed
    }
  };
  function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
  }
  function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
  }
  var cachedSetTimeout = defaultSetTimout;
  var cachedClearTimeout = defaultClearTimeout;
  if (typeof global$1.setTimeout === "function") {
    cachedSetTimeout = setTimeout;
  }
  if (typeof global$1.clearTimeout === "function") {
    cachedClearTimeout = clearTimeout;
  }
  function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
      return setTimeout(fun, 0);
    }
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
      cachedSetTimeout = setTimeout;
      return setTimeout(fun, 0);
    }
    try {
      return cachedSetTimeout(fun, 0);
    } catch (e) {
      try {
        return cachedSetTimeout.call(null, fun, 0);
      } catch (e) {
        return cachedSetTimeout.call(this, fun, 0);
      }
    }
  }
  function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
      return clearTimeout(marker);
    }
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
      cachedClearTimeout = clearTimeout;
      return clearTimeout(marker);
    }
    try {
      return cachedClearTimeout(marker);
    } catch (e) {
      try {
        return cachedClearTimeout.call(null, marker);
      } catch (e) {
        return cachedClearTimeout.call(this, marker);
      }
    }
  }
  var queue$1 = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;
  function cleanUpNextTick() {
    if (!draining || !currentQueue) {
      return;
    }
    draining = false;
    if (currentQueue.length) {
      queue$1 = currentQueue.concat(queue$1);
    } else {
      queueIndex = -1;
    }
    if (queue$1.length) {
      drainQueue();
    }
  }
  function drainQueue() {
    if (draining) {
      return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue$1.length;
    while (len) {
      currentQueue = queue$1;
      queue$1 = [];
      while (++queueIndex < len) {
        if (currentQueue) {
          currentQueue[queueIndex].run();
        }
      }
      queueIndex = -1;
      len = queue$1.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
  }
  function nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }
    }
    queue$1.push(new Item(fun, args));
    if (queue$1.length === 1 && !draining) {
      runTimeout(drainQueue);
    }
  }
  function Item(fun, array) {
    this.fun = fun;
    this.array = array;
  }
  Item.prototype.run = function () {
    this.fun.apply(null, this.array);
  };
  var title = "browser";
  var platform = "browser";
  var browser = true;
  var env = {};
  var argv = [];
  var version = "";
  var versions$1 = {};
  var release = {};
  var config = {};
  function noop() { }
  var on = noop;
  var addListener = noop;
  var once = noop;
  var off = noop;
  var removeListener = noop;
  var removeAllListeners = noop;
  var emit = noop;
  function binding(name) {
    throw new Error("process.binding is not supported");
  }
  function cwd() {
    return "/";
  }
  function chdir(dir) {
    throw new Error("process.chdir is not supported");
  }
  function umask() {
    return 0;
  }
  var performance = global$1.performance || {};
  var performanceNow = performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow || function () {
    return new Date().getTime();
  };
  function hrtime(previousTimestamp) {
    var clocktime = performanceNow.call(performance) * .001;
    var seconds = Math.floor(clocktime);
    var nanoseconds = Math.floor(clocktime % 1 * 1e9);
    if (previousTimestamp) {
      seconds = seconds - previousTimestamp[0];
      nanoseconds = nanoseconds - previousTimestamp[1];
      if (nanoseconds < 0) {
        seconds--;
        nanoseconds += 1e9;
      }
    }
    return [seconds, nanoseconds];
  }
  var startTime = new Date();
  function uptime() {
    var currentTime = new Date();
    var dif = currentTime - startTime;
    return dif / 1e3;
  }
  var process$3 = {
    nextTick: nextTick,
    title: title,
    browser: browser,
    env: env,
    argv: argv,
    version: version,
    versions: versions$1,
    on: on,
    addListener: addListener,
    once: once,
    off: off,
    removeListener: removeListener,
    removeAllListeners: removeAllListeners,
    emit: emit,
    binding: binding,
    cwd: cwd,
    chdir: chdir,
    umask: umask,
    hrtime: hrtime,
    platform: platform,
    release: release,
    config: config,
    uptime: uptime
  };
  var s = 1e3;
  var m = s * 60;
  var h = m * 60;
  var d = h * 24;
  var w = d * 7;
  var y = d * 365.25;
  var ms = function (val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) {
      return parse(val);
    } else if (type === "number" && isNaN(val) === false) {
      return options.long ? fmtLong(val) : fmtShort(val);
    }
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
  };
  function parse(str) {
    str = String(str);
    if (str.length > 100) {
      return;
    }
    var match = /^((?:\d+)?\-?\d?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) {
      return;
    }
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch (type) {
      case "years":
      case "year":
      case "yrs":
      case "yr":
      case "y":
        return n * y;

      case "weeks":
      case "week":
      case "w":
        return n * w;

      case "days":
      case "day":
      case "d":
        return n * d;

      case "hours":
      case "hour":
      case "hrs":
      case "hr":
      case "h":
        return n * h;

      case "minutes":
      case "minute":
      case "mins":
      case "min":
      case "m":
        return n * m;

      case "seconds":
      case "second":
      case "secs":
      case "sec":
      case "s":
        return n * s;

      case "milliseconds":
      case "millisecond":
      case "msecs":
      case "msec":
      case "ms":
        return n;

      default:
        return undefined;
    }
  }
  function fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= d) {
      return Math.round(ms / d) + "d";
    }
    if (msAbs >= h) {
      return Math.round(ms / h) + "h";
    }
    if (msAbs >= m) {
      return Math.round(ms / m) + "m";
    }
    if (msAbs >= s) {
      return Math.round(ms / s) + "s";
    }
    return ms + "ms";
  }
  function fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= d) {
      return plural(ms, msAbs, d, "day");
    }
    if (msAbs >= h) {
      return plural(ms, msAbs, h, "hour");
    }
    if (msAbs >= m) {
      return plural(ms, msAbs, m, "minute");
    }
    if (msAbs >= s) {
      return plural(ms, msAbs, s, "second");
    }
    return ms + " ms";
  }
  function plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
  }
  function setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = ms;
    Object.keys(env).forEach(key => {
      createDebug[key] = env[key];
    });
    createDebug.instances = [];
    createDebug.names = [];
    createDebug.skips = [];
    createDebug.formatters = {};
    function selectColor(namespace) {
      let hash = 0;
      for (let i = 0; i < namespace.length; i++) {
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0;
      }
      return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    function createDebug(namespace) {
      let prevTime;
      function debug(...args) {
        if (!debug.enabled) {
          return;
        }
        const self = debug;
        const curr = Number(new Date());
        const ms$$1 = curr - (prevTime || curr);
        self.diff = ms$$1;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        args[0] = createDebug.coerce(args[0]);
        if (typeof args[0] !== "string") {
          args.unshift("%O");
        }
        let index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
          if (match === "%%") {
            return match;
          }
          index++;
          const formatter = createDebug.formatters[format];
          if (typeof formatter === "function") {
            const val = args[index];
            match = formatter.call(self, val);
            args.splice(index, 1);
            index--;
          }
          return match;
        });
        createDebug.formatArgs.call(self, args);
        const logFn = self.log || createDebug.log;
        logFn.apply(self, args);
      }
      debug.namespace = namespace;
      debug.enabled = createDebug.enabled(namespace);
      debug.useColors = createDebug.useColors();
      debug.color = selectColor(namespace);
      debug.destroy = destroy;
      debug.extend = extend;
      if (typeof createDebug.init === "function") {
        createDebug.init(debug);
      }
      createDebug.instances.push(debug);
      return debug;
    }
    function destroy() {
      const index = createDebug.instances.indexOf(this);
      if (index !== -1) {
        createDebug.instances.splice(index, 1);
        return true;
      }
      return false;
    }
    function extend(namespace, delimiter) {
      return createDebug(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
    }
    function enable(namespaces) {
      createDebug.save(namespaces);
      createDebug.names = [];
      createDebug.skips = [];
      let i;
      const split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
      const len = split.length;
      for (i = 0; i < len; i++) {
        if (!split[i]) {
          continue;
        }
        namespaces = split[i].replace(/\*/g, ".*?");
        if (namespaces[0] === "-") {
          createDebug.skips.push(new RegExp("^" + namespaces.substr(1) + "$"));
        } else {
          createDebug.names.push(new RegExp("^" + namespaces + "$"));
        }
      }
      for (i = 0; i < createDebug.instances.length; i++) {
        const instance = createDebug.instances[i];
        instance.enabled = createDebug.enabled(instance.namespace);
      }
    }
    function disable() {
      const namespaces = [...createDebug.names.map(toNamespace), ...createDebug.skips.map(toNamespace).map(namespace => "-" + namespace)].join(",");
      createDebug.enable("");
      return namespaces;
    }
    function enabled(name) {
      if (name[name.length - 1] === "*") {
        return true;
      }
      let i;
      let len;
      for (i = 0, len = createDebug.skips.length; i < len; i++) {
        if (createDebug.skips[i].test(name)) {
          return false;
        }
      }
      for (i = 0, len = createDebug.names.length; i < len; i++) {
        if (createDebug.names[i].test(name)) {
          return true;
        }
      }
      return false;
    }
    function toNamespace(regexp) {
      return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    function coerce(val) {
      if (val instanceof Error) {
        return val.stack || val.message;
      }
      return val;
    }
    createDebug.enable(createDebug.load());
    return createDebug;
  }
  var common = setup;
  var browser$1 = createCommonjsModule(function (module, exports) {
    exports.log = log;
    exports.formatArgs = formatArgs;
    exports.save = save;
    exports.load = load;
    exports.useColors = useColors;
    exports.storage = localstorage();
    exports.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"];
    function useColors() {
      if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) {
        return true;
      }
      if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
        return false;
      }
      return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    function formatArgs(args) {
      args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module.exports.humanize(this.diff);
      if (!this.useColors) {
        return;
      }
      const c = "color: " + this.color;
      args.splice(1, 0, c, "color: inherit");
      let index = 0;
      let lastC = 0;
      args[0].replace(/%[a-zA-Z%]/g, match => {
        if (match === "%%") {
          return;
        }
        index++;
        if (match === "%c") {
          lastC = index;
        }
      });
      args.splice(lastC, 0, c);
    }
    function log(...args) {
      return typeof console === "object" && console.log && console.log(...args);
    }
    function save(namespaces) {
      try {
        if (namespaces) {
          exports.storage.setItem("debug", namespaces);
        } else {
          exports.storage.removeItem("debug");
        }
      } catch (error) { }
    }
    function load() {
      let r;
      try {
        r = exports.storage.getItem("debug");
      } catch (error) { }
      if (!r && typeof process$3 !== "undefined" && "env" in process$3) {
        r = process$3.env.DEBUG;
      }
      return r;
    }
    function localstorage() {
      try {
        return localStorage;
      } catch (error) { }
    }
    module.exports = common(exports);
    const { formatters: formatters } = module.exports;
    formatters.j = function (v) {
      try {
        return JSON.stringify(v);
      } catch (error) {
        return "[UnexpectedJSONParseError]: " + error.message;
      }
    };
  });
  var browser_1 = browser$1.log;
  var browser_2 = browser$1.formatArgs;
  var browser_3 = browser$1.save;
  var browser_4 = browser$1.load;
  var browser_5 = browser$1.useColors;
  var browser_6 = browser$1.storage;
  var browser_7 = browser$1.colors;
  var getQueryString = function (variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i += 1) {
      var pair = vars[i].split("=");
      if (pair[0] === variable) {
        return escape(decodeURIComponent(pair[1]));
      }
    }
    return false;
  };
  var localStorage$1 = window.sessionStorage;
  var getItem = function getItem(name) {
    try {
      var serializedState = localStorage$1.getItem(name);
      if (serializedState === null) {
        return undefined;
      }
      return JSON.parse(serializedState);
    } catch (err) {
      return undefined;
    }
  };
  var removeItem = function removeItem(name) {
    try {
      localStorage$1.removeItem(name);
    } catch (err) { }
  };
  var setItem = function setItem(name, state) {
    try {
      var serializedState = JSON.stringify(state);
      localStorage$1.setItem(name, serializedState);
    } catch (_unused) { }
  };
  var qs = getQueryString("beamDebug");
  if (qs) {
    if (qs.toLowerCase() === "true" || qs === "1") {
      setItem("debugMode", true);
    } else if (qs.toLowerCase() === "false" || qs === "0") {
      removeItem("debugMode");
    }
  }
  if (getItem("debugMode")) {
    browser$1.enable("beam*");
    browser$1.log = console.log.bind(console);
  } else {
    browser$1.disable();
  }
  var debug = function () {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "debug";
    return function () {
      for (var _len = arguments.length, message = new Array(_len), _key = 0; _key < _len; _key++) {
        message[_key] = arguments[_key];
      }
      var output = message.map(function (msg) {
        if (isPlainObject$1(msg)) {
          return deepMerge(msg);
        }
        return msg;
      });
      return browser$1("beam:".concat(name)).apply(void 0, _toConsumableArray(output));
    };
  };
  function get$1(obj, path) {
    var def = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var splitPath = function splitPath(input) {
      if (typeof input !== "string") {
        return input;
      }
      var output = [];
      input.split(".").forEach(function (item) {
        item.split(/\[([^}]+)\]/g).forEach(function (key) {
          if (key.length > 0) {
            output.push(key);
          }
        });
      });
      return output;
    };
    var pathArray = splitPath(path);
    var current = obj;
    for (var i = 0; i < pathArray.length; i += 1) {
      if (!current[pathArray[i]]) {
        return def;
      }
      current = current[pathArray[i]];
    }
    return current;
  }
  var isFunction = function (input) {
    return typeof input === "function";
  };
  var log = debug("utils:callFn");
  var callFnByName = function callFnByName(fn) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
    var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    if (isUndefined(fn) || !isString(fn)) {
      throw new Error("A function name was not specified");
    }
    var namespaces = fn.split(".");
    var name = namespaces.pop();
    if (namespaces.length > 0) {
      context = get$1(context, namespaces.join("."), context);
    }
    var newFn = context[name];
    if (!isFunction(newFn)) {
      throw new Error('"'.concat(context, ".").concat(name, '" is not a function'));
    }
    return newFn.apply(context, args);
  };
  var callFn = function (fn) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var result = "";
    try {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }
      if (isFunction(fn)) {
        result = context ? fn.apply(context, args) : fn(args);
      } else if (isString(fn)) {
        result = callFnByName(fn, context, args);
      }
    } catch (err) {
      log("Error", fn, context, err);
      result = "";
    }
    return result;
  };
  var uuid = function () {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (char) {
      var rand = Math.random() * 16 | 0;
      var val = char === "x" ? rand : rand & 3 | 8;
      return val.toString(16);
    });
  };
  var log$1 = debug("wildcard");
  var findForm = function findForm(element) {
    var form = element.closest("form");
    return form || element;
  };
  var wildcard = function (input) {
    var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
    if (!isString(input)) {
      return input;
    }
    var output = "";
    try {
      if (input.indexOf("data.") === 0) {
        output = el.dataset[input.replace("data.", "").trim()];
      } else if (input.indexOf("var.") === 0) {
        var _store$getState = store.getState(), vars = _store$getState.vars;
        var variable = input.replace("var.", "").trim();
        if (variable && variable in vars) {
          output = vars[variable];
        } else {
          log$1('Unknown variable requested: "'.concat(input, '"'));
        }
      } else if (input.indexOf("qs.") === 0) {
        output = getQueryString(input.replace("qs.", "").trim());
      } else if (input.indexOf("fn.") === 0) {
        output = callFn(input.replace("fn.", "").trim());
      } else {
        switch (input) {
          case "uuid":
          case "this.uuid":
            output = uuid();
            break;

          case "page.href":
            output = window.location.href;
            break;

          case "page.referrer":
            output = document.referrer ? document.referrer : "direct entry";
            break;

          case "page.title":
            output = document.title;
            break;

          case "form.id":
            output = findForm(el).getAttribute("id");
            break;

          case "form.name":
            output = findForm(el).getAttribute("name");
            break;

          case "this.href":
            output = el.getAttribute("href");
            break;

          case "this.innerText":
            output = el.innerText;
            break;

          case "this.rel":
            output = el.getAttribute("rel");
            break;

          case "this.title":
            output = el.getAttribute("title");
            break;

          case "this.alt":
            output = el.getAttribute("alt");
            break;

          case "this.id":
            output = el.getAttribute("id");
            break;

          case "this.name":
            output = el.getAttribute("name");
            break;

          case "this.type":
            output = el.getAttribute("type");
            if (["text", "email", "tel", "textarea"].indexOf(output) !== -1) {
              output = "enum";
            }
            break;

          case "this.value":
            output = el.value;
            break;

          default:
            output = input;
        }
      }
    } catch (err) {
      log$1("Error", input, el);
      output = "";
    }
    if (!output) {
      output = "";
    }
    return output;
  };
  var strip = function strip(input) {
    return typeof input === "string" ? input.replace(/[^\x00-\x7F]+/gi, "").replace(/(\r\n|\n|\r)/gm, " ").replace(/\s+/g, " ").trim() : input;
  };
  var normalize = function normalize(input) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    switch (_typeof(input)) {
      case "string":
        return strip(wildcard(input, context));

      case "function":
        return callFn(input, context);

      default:
        return strip(input);
    }
  };
  var typeCast = function (input, type) {
    switch (type) {
      case "string":
        return "".concat(input);

      case "number":
        return Number(input) || 0;

      case "integer":
        return parseInt("".concat(input), 10) || 0;

      case "boolean":
        return !!input;

      default:
        return input;
    }
  };
  var composer = function composer(data, context) {
    return function (state, _ref) {
      var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], props = _ref2[1];
      if (key in data) {
        var input = data[key];
        var required = props.required, type = props.type;
        if (["string", "number", "integer", "boolean"].includes(type)) {
          var value = normalize(input, context);
          if (!isEmpty(value) || required) {
            state[key] = typeCast(value, type);
          }
        } else {
          var composed = composer(input, context);
          if (type === "object") {
            state[key] = Object.entries(props.properties).reduce(composed, {});
          } else if (type === "array") {
            state[key] = props.items.reduce(composed, []);
          } else if (type === "enum") {
            state[key] = props.items.reduce(composed, []);
          }
        }
      }
      return state;
    };
  };
  var composeData = function (_ref3) {
    var context = _ref3.context, data = _ref3.data, event = _ref3.event, interpolate = _ref3.interpolate;
    if (hasOwnProperty$1(eventsList, event) && interpolate) {
      var _events$event = eventsList[event], type = _events$event.type, schema = _events$event.schema;
      var composed = composer(data, context);
      return Object.entries(schema).reduce(composed, {
        "@type": type
      });
    }
    return data;
  };
  var validate = function (payload) {
    var _window$_Cohesion = window._Cohesion, anonymousId = _window$_Cohesion.anonymousId, writeKey = _window$_Cohesion.writeKey;
    var _window$_Tagular = window._Tagular, apiKey = _window$_Tagular.config.apiKey, webContext = _window$_Tagular.webContext;
    var headers = new Headers();
    headers.set("Authorization", "Basic ".concat(window.btoa(writeKey), ":"));
    var event = payload["@type"];
    var properties = deepMerge(payload);
    delete properties["@type"];
    if (event.indexOf(".Alias") === -1) {
      properties.webContext = webContext;
    }
    var request = new XMLHttpRequest();
    request.open("POST", "https://make.cohesionapps.com/v1/validate", true);
    request.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
    request.setRequestHeader("Authorization", "Basic ".concat(window.btoa("".concat(writeKey, ":"))));
    request.send(JSON.stringify({
      anonymousId: anonymousId,
      messageId: uuid(),
      event: event,
      properties: properties,
      sentAt: new Date().toISOString(),
      writeKey: apiKey
    }));
  };
  var log$2 = debug("track");
  var getSchemaType = function getSchemaType(type) {
    return type.split(".").pop();
  };
  var subjectDefaults = {
    context: document,
    data: null,
    event: null,
    interpolate: true
  };
  var subjectReducer = function subjectReducer(parameters) {
    return parameters.reduce(function (state, param) {
      if (isString(param)) {
        state.event = param;
      } else if (isPlainObject$1(param)) {
        state.data = param;
        if (state.event == null) {
          state.event = getSchemaType(param["@type"]);
        }
      } else if (param instanceof Element) {
        state.context = param;
      } else if (typeof param === "boolean") {
        state.interpolate = param;
      }
      return state;
    }, subjectDefaults);
  };
  var track = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var subject = subjectReducer(args);
    if (!subject.data || !subject.event) {
      log$2("Error: Beam was not sent! Subject is invalid.", {
        subject: subject
      });
      return;
    }
    var payload = composeData(subject);
    if (subject.event.indexOf("ProductViewed") !== -1) {
      if (hasOwnProperty$1(payload, "actionOutcome")) {
        delete payload.actionOutcome;
      }
      if (hasOwnProperty$1(payload, "correlationId")) {
        delete payload.correlationId;
      }
      if (hasOwnProperty$1(payload, "outboundUrl")) {
        delete payload.outboundUrl;
      }
    }
    try {
      if (hasOwnProperty$1(window, "tagular")) {
        if (getItem("debugMode")) {
          validate(payload);
        } else {
          window.tagular("beam", subject.event, payload);
        }
        log$2('Beam sent: "'.concat(subject.event, '"!'), {
          subject: subject,
          payload: payload
        });
      }
      if (hasOwnProperty$1(window, "dataLayer")) {
        var gtmEvent = deepMerge({
          event: "beam"
        }, payload);
        window.dataLayer.push(gtmEvent);
        log$2('GTM dataLayer updated: "beam"!', {
          gtmEvent: gtmEvent
        });
      }
    } catch (error) {
      log$2("Error: Beam was not sent!", {
        subject: subject,
        payload: payload,
        error: error
      });
      console.error(error.message);
    }
  };
  var BEAM = "BEAM";
  var PRODUCTVIEWED = "PRODUCTVIEWED";
  var BeamEvent = new CustomEvent(BEAM, {
    bubbles: true,
    cancelable: true
  });
  var ProductViewed = new CustomEvent(PRODUCTVIEWED, {
    bubbles: true,
    cancelable: true
  });
  var noop$1 = function () { };
  var defaults = {
    root: null,
    rootMargin: "0px",
    threshold: [0, 1]
  };
  var createObserver = function () {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop$1;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaults;
    return new IntersectionObserver(callback, options);
  };
  var log$3 = debug("observer");
  var observerDefaults = {
    root: null,
    rootMargin: "0px",
    threshold: [.25, .5, .75, 1]
  };
  var observerHandler = function observerHandler(entries, observer) {
    entries.forEach(function (entry) {
      var isIntersecting = entry.isIntersecting, target = entry.target;
      if (isIntersecting) {
        if (observer.name && observer.name.includes("ProductViewed") && observer.options && observer.options.addProductViewed === true) {
          target.dispatchEvent(ProductViewed);
        } else {
          target.dispatchEvent(BeamEvent);
        }
        observer.unobserve(target);
      }
    });
  };
  var observer = function (target) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _store$getState = store.getState(), observers = _store$getState.observers;
    var observer = observers[name];
    if (!observer) {
      log$3('Creating new Intersection Observer: "'.concat(name, '"'));
      var options = deepMerge(observerDefaults, config);
      observer = createObserver(observerHandler, options);
      observer.options = options;
      observer.name = name;
      store.dispatch({
        type: ADD_OBSERVER,
        name: name,
        observer: observer
      });
    }
    observer.observe(target);
  };
  var log$4 = debug("clickHandler");
  var clickDefaults = {
    addParamsToHref: false,
    addProductViewed: false,
    delay: false,
    once: false
  };
  var clickHandler = function (event) {
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var element = arguments.length > 2 ? arguments[2] : undefined;
    if (!element || !element.hasAttribute("data-tagular-uid")) {
      return;
    }
    var options = deepMerge(clickDefaults, settings);
    var disabled = element.disabled || element.getAttribute("aria-disabled") === "true";
    if (disabled) {
      return;
    }
    element.dispatchEvent(BeamEvent);
    if (options.once) {
      var uid = element.getAttribute("data-tagular-uid");
      log$4("Removing UID=".concat(uid, ' because "once" option was declared.'));
      store.dispatch({
        type: REMOVE_EVENT,
        uid: uid
      });
    }
    var href = element.getAttribute("href");
    if (options.delay && href && href.indexOf("#") !== 0 && element.getAttribute("target") !== "_blank") {
      event.preventDefault();
      log$4('Delaying link follow slightly to allow "beam" to send.');
      setTimeout(function () {
        window.location = element.href;
      }, 100);
    }
  };
  var originalLink = "data-tagular-link";
  var addParamsToHref = function (element) {
    var attr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "href";
    if (!element || !element.hasAttribute("data-tagular-uid")) {
      return;
    }
    var link = element.getAttribute(originalLink);
    if (!link) {
      link = element.getAttribute(attr);
      element.setAttribute(originalLink, link);
    }
    if (!link || link === "#") {
      return;
    }
    var _window$_Cohesion = window._Cohesion, anonymousId = _window$_Cohesion.anonymousId, instanceId = _window$_Cohesion.instanceId, sessionId = _window$_Cohesion.sessionId, tenantId = _window$_Cohesion.tenantId;
    var cohesionParams = {
      c_anonymous_id: anonymousId,
      c_correlation_id: uuid(),
      c_instance_id: instanceId,
      c_session_id: sessionId,
      c_tenant_id: tenantId
    };
    var url = new URL(link);
    Object.entries(cohesionParams).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2), name = _ref2[0], value = _ref2[1];
      url.searchParams.append(name, value);
    });
    element.setAttribute(attr, url.href);
  };
  var log$5 = debug("bind");
  var getBrowserEvent = function getBrowserEvent(type, config) {
    if (config && hasOwnProperty$1(config, "event") && isString(config.event)) {
      return config.event.toLowerCase();
    }
    var schema = eventsList[type];
    if (isPlainObject$1(schema) && hasOwnProperty$1(schema, "event")) {
      return schema.event.toLowerCase();
    }
    return false;
  };
  var alreadyBound = function alreadyBound(el) {
    return el.hasAttribute("data-tagular-uid");
  };
  var bind = function (_ref) {
    var elements = _ref.elements, _ref$data = _ref.data, data = _ref$data === void 0 ? {} : _ref$data, _ref$settings = _ref.settings, settings = _ref$settings === void 0 ? {} : _ref$settings;
    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!hasOwnProperty$1(data, "@type")) {
      log$5('Error: No tagular event ("@type") was specified.', {
        elements: elements,
        data: data,
        settings: settings
      });
      return;
    }
    var type = data["@type"];
    var browserEvent = getBrowserEvent(type, settings);
    var _store$getState = store.getState(), uid = _store$getState.uid;
    store.dispatch({
      type: MAP_DATA,
      data: data,
      uid: uid
    });
    store.dispatch({
      type: INCREMENT_UID
    });
    if (!isString(browserEvent)) {
      log$5("Error: No browser event was specified.", {
        browserEvent: browserEvent,
        elements: elements,
        data: data,
        settings: settings,
        uid: uid
      });
      return;
    }
    _toConsumableArray(elements).forEach(function (element, index) {
      if (alreadyBound(element)) {
        if (!reload) {
          log$5("Element already has an event.", element);
        }
        return;
      }
      element.setAttribute("data-tagular-event", type);
      element.setAttribute("data-tagular-uid", uid);
      element.setAttribute("data-tagular-index", index + 1);
      switch (browserEvent) {
        case "scroll":
        case "view":
          observer(element, "".concat(type, ":").concat(uid), settings);
          break;

        case "click":
        case "contextmenu":
        case "mousedown":
        case "focus":
        case "blur":
        case "change":
        case "touchcancel":
        case "touchstart":
        case "touchstop":
        case "touchmove":
        case "submit":
          element.addEventListener(browserEvent, function (event) {
            return setTimeout(function () {
              return clickHandler(event, settings, element);
            }, 0);
          });
          if (type.toLowerCase() === "productclicked") {
            if (hasOwnProperty$1(settings, "addProductViewed") && settings.addProductViewed === true) {
              observer(element, "ProductViewed:".concat(uid), settings);
            }
            if (hasOwnProperty$1(settings, "addParamsToHref") && !!settings.addParamsToHref) {
              element.addEventListener("mousedown", function () {
                return addParamsToHref(element, settings.addParamsToHref);
              });
            }
          }
          break;

        default:
          log$5("Event type not supported.", deepMerge({
            type: type,
            element: element
          }));
          break;
      }
    });
  };
  var log$6 = debug("parse");
  var parse$1 = function (source) {
    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    log$6("Binding events to elements...");
    if (!isPlainObject$1(source)) {
      log$6("Error: Cannot process source data; it is not an object.", source);
      return;
    }
    if (!reload) {
      store.dispatch({
        type: SOURCECACHE,
        source: source
      });
    }
    Object.entries(source).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2), selector = _ref2[0], config = _ref2[1];
      var elements = document.querySelectorAll(selector);
      var data = hasOwnProperty$1(config, "data") ? config.data : config;
      var settings = config.settings ? config.settings : {};
      bind({
        elements: elements,
        data: data,
        settings: settings
      }, reload);
    });
  };
  var log$7 = debug("init");
  var processQueue = function processQueue() {
    var _store$getState = store.getState(), queue = _store$getState.queue;
    if (queue && queue.length > 0) {
      log$7("Processing queued sources.", queue.length);
      var source = queue[0];
      parse$1(source);
      store.dispatch({
        type: DEQUEUE
      });
      processQueue();
    }
  };
  var triggerTrack = function triggerTrack(event, eventType) {
    var context = event.target.closest("[data-tagular-uid]");
    var uid = context.getAttribute("data-tagular-uid");
    var type = eventType || context.getAttribute("data-tagular-event");
    var state = store.getState();
    var data = state.data[uid];
    if (!type || !data) {
      log$7("Error in triggerTrack:", {
        data: data,
        event: event,
        type: type
      });
      return;
    }
    track(type, data, context, true);
  };
  var triggerProductViewed = function triggerProductViewed(event) {
    return triggerTrack(event, "ProductViewed");
  };
  var setupEventListeners = function setupEventListeners() {
    log$7("Setting up global event listeners.");
    window.removeEventListener(BEAM, triggerTrack, true);
    window.removeEventListener(PRODUCTVIEWED, triggerProductViewed, true);
    window.addEventListener(BEAM, triggerTrack, true);
    window.addEventListener(PRODUCTVIEWED, triggerProductViewed, true);
  };
  var _init = function () {
    var _store$getState2 = store.getState(), initialized = _store$getState2.initialized;
    if (!initialized && hasOwnProperty$1(window, "cohesion")) {
      window.cohesion("ready", function () {
        try {
          setupEventListeners();
          processQueue();
          store.dispatch({
            type: INITIALIZE
          });
          log$7("Initialized.");
        } catch (error) {
          log$7("Error", error);
        }
      });
    }
  };
  var vars = function (vars) {
    store.dispatch({
      type: ADD_VARS,
      vars: vars
    });
  };
  var log$8 = debug("setup");
  var setup$1 = function (source) {
    var _store$getState = store.getState(), initialized = _store$getState.initialized;
    log$8("Beginning setup...");
    if (initialized) {
      parse$1(source);
    } else {
      store.dispatch({
        type: ENQUEUE,
        source: source
      });
    }
  };
  var log$9 = debug("utils:request");
  var request = function (url) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;
    if (!isString(url)) {
      log$9("Cannot fetch URL. It is not a String.", url);
      return false;
    }
    return fetch(url).then(function (response) {
      if (!response.ok || response.status >= 200 && response.status < 400) {
        throw new Error("Network response was not ok.");
      }
      return response.json();
    }).then(function (data) {
      callback(data);
    }).catch(function (error) {
      log$9("There was an error processing: ".concat(url), error);
    });
  };
  var log$a = debug("start");
  var start = function (source) {
    if (isString(source)) {
      request(source, setup$1);
    } else if (isPlainObject$1(source)) {
      setup$1(source);
    } else {
      log$a("Source is not a valid string or object.", source);
    }
  };
  var log$b = debug("load");
  var _load = function (source) {
    log$b("Loading source.");
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    if (rest.length > 0) {
      log$b.apply(void 0, ["Loading other parameters."].concat(rest));
      rest.forEach(function (arg) {
        if (isPlainObject$1(arg)) {
          vars(arg);
        } else if (isString(arg)) {
          store.dispatch({
            type: SCRIPT_PATH,
            path: arg
          });
        }
      });
    }
    start(source);
  };
  var _reload = function () {
    var _store$getState = store.getState(), sourceCache = _store$getState.sourceCache;
    if (sourceCache) {
      parse$1(sourceCache, true);
    }
  };
  var beam = window._Beam = {
    init: function init() {
      return _init.apply(void 0, arguments);
    },
    load: function load() {
      return _load.apply(void 0, arguments);
    },
    reload: function reload() {
      return _reload.apply(void 0, arguments);
    },
    track: function track$$1() {
      return track.apply(void 0, arguments);
    },
    vars: function vars$$1() {
      return vars.apply(void 0, arguments);
    }
  };
  if (document.readyState === "complete" || document.readyState === "interactive") {
    beam.init();
  } else {
    document.addEventListener("DOMContentLoaded", beam.init);
  }
})();
